var _defs, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeyvisualXsRgb = function SvgKeyvisualXsRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 300,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 720 300",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_2",
    cx: 1931.75,
    cy: 101.35,
    fx: 1931.75,
    fy: 101.35,
    r: 39.7,
    gradientTransform: "translate(2132.57) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffecde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb1527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb1a2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ec2a37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ee454b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f16a67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f5998c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f9d2b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcf4d1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_79",
    cx: 84.19,
    cy: 383.09,
    fx: 84.19,
    fy: 383.09,
    r: 36.85,
    gradientTransform: "translate(0 -240.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f7fafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e0edf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#b7d8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#73bce5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58b3e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_78",
    x1: 1168.82,
    y1: 546.8,
    x2: 1221.11,
    y2: 546.8,
    gradientTransform: "translate(-629.5 -879.68) rotate(30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d1e1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c2d0da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#abb5bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8c9398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74787a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_76",
    cx: 79.58,
    cy: 374.72,
    fx: 79.58,
    fy: 374.72,
    r: 38.32,
    gradientTransform: "translate(0 -240.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f9fcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e9f2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e1edd8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_77",
    cx: 114.44,
    cy: 412.62,
    fx: 114.44,
    fy: 412.62,
    r: 38.57,
    gradientTransform: "translate(0 -240.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef5bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f6f3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e6efd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1edd8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_42",
    x1: 353.43,
    y1: 1558.05,
    x2: 353.43,
    y2: 1448.46,
    gradientTransform: "translate(0 -1414.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb5b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbfb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdd7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fee8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fef2bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_41",
    x1: 585.62,
    y1: 6213.41,
    x2: 585.62,
    y2: 6170.94,
    gradientTransform: "translate(0 -6098.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dfecf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffecde"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_43",
    x1: -536.23,
    y1: -3439.96,
    x2: -536.23,
    y2: -3482.72,
    gradientTransform: "translate(678.61 -3214.92) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#444a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#465374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#475b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#49619b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4a65a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4a68ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b69b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_72",
    x1: 2421.1,
    y1: -3479.2,
    x2: 2401.91,
    y2: -3479.2,
    gradientTransform: "translate(-1927.06 3743.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#cedeea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8d9599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74787a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_72-2",
    x1: 2420.81,
    y1: -3491.29,
    x2: 2408.67,
    y2: -3491.29,
    gradientTransform: "translate(2895.96 -3214.92) rotate(-180)",
    xlinkHref: "#Unbenannter_Verlauf_72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_71",
    x1: 2388.59,
    y1: -3465.96,
    x2: 2391.99,
    y2: -3471.85,
    gradientTransform: "translate(-1884.62 3722.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#74787a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_70",
    x1: 2379.38,
    y1: -3445.19,
    x2: 2389.68,
    y2: -3473.66,
    gradientTransform: "translate(2895.96 -3214.92) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#74787a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_69",
    x1: 2371.72,
    y1: -3491.27,
    x2: 2407.02,
    y2: -3491.27,
    gradientTransform: "translate(2895.96 -3214.92) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#d6e7f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_69-2",
    x1: 2416.02,
    y1: -3502.66,
    x2: 2426.45,
    y2: -3502.66,
    xlinkHref: "#Unbenannter_Verlauf_69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_61",
    x1: 2856.12,
    y1: -3376.85,
    x2: 2856.12,
    y2: -3425.09,
    gradientTransform: "translate(3397.39 -3214.92) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cabf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f7bdb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f39b96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ec6466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb5b5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_46",
    x1: 3482.77,
    y1: -1241.38,
    x2: 3478.25,
    y2: -1216.09,
    gradientTransform: "translate(2085.26 -3162.19) rotate(133.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f5f2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dbe9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d6e8f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_68",
    x1: 3003.27,
    y1: -3443.66,
    x2: 3008.71,
    y2: -3440.52,
    gradientTransform: "translate(3349.81 -3214.92) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdf2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#faefe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f3e8de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e6dcd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#d3cbc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#bbb5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9d9999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7a787d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#52535d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484a55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_67",
    x1: 2102.67,
    y1: -4224.03,
    x2: 2102.67,
    y2: -4185.91,
    gradientTransform: "translate(3991.11 -2627.48) rotate(-154.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d6e7f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#d4e5f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#cedfeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c5d4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#b7c4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a5b0b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8f979d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#74797d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#575758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_66",
    x1: 2970.67,
    y1: -3505.03,
    x2: 2970.67,
    y2: -3463.1,
    gradientTransform: "translate(3349.81 -3214.92) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4967ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4865a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#48609a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#465883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#454d63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44454b"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 197.94,
    y: 137.34,
    width: 6.16,
    height: 105.3,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2,152.87l-21.91,1.33,14.72,16.52c.89.37,1.63,1.09,2.7,1.54,4.98,2.06,10.94-.26,13.08-5.41s-.26-10.94-5.41-13.08c-5.16-2.14-1.42-.59-3.17-.9",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.28,
    y1: 154.2,
    x2: 196.87,
    y2: 166.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.95,194.47l22.12.32-14.17,17.22c-.79.58-1.58,1.16-2.63,1.65-5.06,2.36-11.02.04-13.3-4.85s-.04-11.02,4.85-13.3c4.89-2.27,1.57-.73,3.13-1.03",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.04,
    y1: 194.48,
    x2: 204.58,
    y2: 208.66,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.99 63.14 210.45 67.66 210.07 74.01 210.07 77.29 215.46 72.09 222.48 69.2 229.03 73.44 231.91 78.63 230.76 84.02 226.14 89.61 224.02 90.86 231.34 91.05 235.19 92.2 239.61 96.44 240.67 102.79 237.69 108.76 230.76 111.07 224.02 110.68 230.95 117.33 232.11 123.1 230.57 127.14 226.33 130.61 223.25 131.57 218.05 131.57 214.3 127.72 210.84 124.45 210.84 130.41 210.26 134.07 206.02 139.37 202.56 140.91 197.94 140.91 194.28 138.4 191.3 134.07 190.53 124.83 185.91 129.64 183.6 131.18 178.79 132.15 173.4 129.64 170.32 124.83 170.32 119.44 176.48 110.68 169.16 110.68 165.41 109.34 162.33 105.68 160.98 100.29 165.02 92.78 169.93 91.24 177.82 91.82 171.47 85.95 169.93 80.37 171.09 74.78 174.17 71.32 180.13 69.2 185.14 70.55 188.6 74.21 191.11 77.09 190.91 69.2 193.7 63.91 198.52 61.79 201.6 61.79 205.25 62.37 206.99 63.14",
    style: {
      fill: "url(#Unbenannter_Verlauf_2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,91.24l4.62-4.62c3.85-3.85,3.85-10.01,0-13.96-3.85-3.85-10.01-3.85-13.96,0l-4.23,4.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.91,124.64l-4.23,4.43c-3.85,3.85-10.01,3.85-13.96,0-3.95-3.85-3.85-10.01,0-13.96l4.43-4.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.84,124.83l4.23,4.23c3.85,3.85,10.01,3.85,13.96,0,4.04-3.85,3.85-10.01,0-13.96l-4.62-4.62",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44,91.24l-4.62-4.62c-3.85-3.85-3.85-10.01,0-13.96,3.85-3.85,10.01-3.85,13.96,0l4.43,4.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.64,101.06v-29.93c0-5.39-4.43-9.82-9.82-9.82s-9.82,4.43-9.82,9.82v29.93s19.73,0,19.73,0h-.19s.1,0,.1,0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.64,101.06v29.93c0,5.39-4.43,9.82-9.82,9.82-5.39,0-9.82-4.43-9.82-9.82v-29.93h19.73s-.19,0-.19,0h.1Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.83,110.68h29.93c5.39,0,9.82-4.43,9.82-9.82s-4.43-9.82-9.82-9.82h-29.93s0,19.73,0,19.73h0v-.19s0,.1,0,.1Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.83,110.68h-29.93c-5.39,0-9.82-4.43-9.82-9.82s4.43-9.82,9.82-9.82h29.93v19.73h0v-.19s0,.1,0,.1Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.56,
    y1: 115.98,
    x2: 202.56,
    y2: 129.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.67,
    y1: 118.87,
    x2: 199.67,
    y2: 132.15,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.52,
    y1: 72.28,
    x2: 201.6,
    y2: 85.37,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.75,
    y1: 72.67,
    x2: 199.09,
    y2: 80.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.87,
    y1: 114.82,
    x2: 180.52,
    y2: 121.37,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.87,
    y1: 114.82,
    x2: 179.56,
    y2: 117.52,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.4,
    y1: 82.29,
    x2: 212.18,
    y2: 89.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.57,
    y1: 89.61,
    x2: 181.29,
    y2: 81.33,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.49,
    y1: 82.29,
    x2: 181.67,
    y2: 77.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.29,
    y1: 122.52,
    x2: 214.11,
    y2: 114.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.9,
    y1: 126.18,
    x2: 216.9,
    y2: 121.17,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.53,
    y1: 101.06,
    x2: 216.32,
    y2: 101.06,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.75,
    y1: 105.1,
    x2: 216.32,
    y2: 103.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.68,
    y1: 96.05,
    x2: 218.44,
    y2: 97.79,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.14,
    y1: 101.06,
    x2: 173.2,
    y2: 101.06,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.14,
    y1: 98.17,
    x2: 175.9,
    y2: 96.63,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.02,
    cy: 101.06,
    r: 17.04,
    style: {
      fill: "#fcf4d1",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.09,
    y: 227.6,
    width: 3.58,
    height: 9.58,
    style: {
      fill: "#020202",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.51,
    y: 219.27,
    width: 7.32,
    height: 2.18,
    transform: "translate(-147.75 184.8) rotate(-60)",
    style: {
      fill: "#020202",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.61,
    y: 136.03,
    width: 7.32,
    height: 2.18,
    transform: "translate(-51.62 184.84) rotate(-60)",
    style: {
      fill: "#020202",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.27,
    cy: 178.23,
    r: 46.49,
    style: {
      fill: "url(#Unbenannter_Verlauf_79)",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.44,132.99c25,14.41,33.56,46.41,19.16,71.41-14.41,25-46.41,33.56-71.41,19.16h0l1.71-2.96c23.36,13.47,53.26,5.45,66.73-17.91,13.47-23.36,5.45-53.26-17.91-66.73l1.71-2.96",
    style: {
      fill: "url(#Unbenannter_Verlauf_78)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.59,
    y: 237.18,
    width: 48.59,
    height: 3.58,
    style: {
      fill: "#d6e7f4",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.77,
    y: 240.84,
    width: 56.14,
    height: 1.79,
    style: {
      fill: "#020202",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.1,142.49c.7.62,1.4,1.32,2.1,1.95,1.01.93,2.02,1.87,2.96,2.96,1.87,2.1,3.35,4.44,4.83,6.85.39.7.78.93,1.09,1.64.16-.08.23.62.31.78,1.95,4.05,3.58,8.18,4.36,12.61.16.78.23,1.56.39,2.34.08.47.16.93.16,1.4.23,1.87.47,3.74.31,5.61-.39.16-.78.39-1.17.7-.08.08-.23.23-.39.23h-.39c-.16,0-.31.16-.39.23-.23.23-.47.39-.7.62-.08.08-.23.16-.31.23s-.31-.08-.31-.16c-.62.7-1.17,1.56-1.64,2.34.31.16.39.55.39.86s-.08.7.08,1.01c.08.16.16.23.23.31.08.16.16.31.16.47.23,1.01.39,2.18-.08,3.11-.08.16-.16.31-.31.39s-.39,0-.39-.16c-.08-.16,0-.31-.16-.31-.31,0-.47.23-.7.47-.23.23-.55.39-.7.08-.08-.16-.16-.47-.31-.39,0-1.01,0-2.1-.08-3.11-.08,0-.16-.08-.23-.08h-.16c-.08.08-.23.16-.31.08-.16-.08-.23-.23-.31-.39-.23-.23-.7,0-1.01-.16-.31-.16-.31-.7-.23-1.09.08-.47.23-.93.31-1.4,0-.16.08-.31-.08-.39-.08-.08-.23,0-.39-.08s-.23-.31-.23-.55c-.08-1.09-.23-2.18-.31-3.27q0-.08-.08-.16c-.08-.16-.39-.08-.47.08-.16.16-.23.39-.39.39s-.23-.08-.39-.08c-.31-.08-.55.16-.7.39s-.23.55-.39.78c-.23.31-.55.39-.86.62-.31.16-.62.47-.62.86-.08,0-.16-.16-.08-.23-.39.86-1.71,1.01-2.18,1.95-.16.23-.16.55-.31.86-.31.78-1.17,1.25-1.4,2.02-.16.47-.08.93,0,1.4.16,1.32,0,2.65-.55,3.82-.08.16-.23.31-.39.23s-.16-.39-.31-.31c0,.23-.31.31-.55.16-.16-.16-.23-.39-.16-.62s.16-.39.31-.62c.39-.7.31-1.64-.08-2.26-.39.23-.47.7-.62,1.17s-.39.93-.86.86v-1.09c0-.08,0-.16-.08-.16s-.16,0-.16.08c.62-.93.16-2.18.39-3.27.08-.16.08-.39.08-.55s-.08-.39-.31-.47c.39-.93.16-2.02.23-3.04,0-.47.08-.93.16-1.32.08-.7.16-1.4.31-2.1-.31.16-.78.23-.93-.08-.08.16-.39.08-.55,0-.23-.16-.55-.16-.78-.39-.55-.62-.31-1.64-.39-2.41-.08-1.25-.93-2.34-2.1-2.73-.23-.08-.39-.16-.55-.31-.08-.16-.16-.31-.23-.39-.16-.23-.47-.31-.78-.31-.47,0-.93-.08-1.48-.08-.39,0-.86-.08-1.25-.23-.55-.23-.86-.7-1.25-1.17-.08-.08-.16-.23-.16-.31-.08-.23.08-.47.08-.7,0-.39-.39-.62-.78-.7s-.78,0-1.09-.16c-.62-.23-1.01-.86-1.32-1.48s-.55-1.32-1.17-1.64c-.55-.31-1.56-.08-1.56.62,0,.47.31.78.39,1.25,0,.23,0,.47.08.62.08.16.23.23.31.39.23.31,0,.78-.08,1.09-.16.39-.08.93.31.93.62.08,1.17.16,1.79.23.16,0,.31,0,.39-.08.16-.08.23-.39.39-.47.31-.16.62.16.62.47s-.08.7,0,.93c.08.23.31.39.47.55.39.31.86.62,1.17,1.01s.55.93.39,1.48c-.16.39-.47.7-.86,1.01-.86.7-1.64,1.4-2.49,2.02-.16.08-.23.23-.39.23-.23.08-.47,0-.7,0-2.41-.39-5.14-.08-7.48.78.08,0,0-.08.08-.08-.16-.47-.93-.39-1.4-.55l.08.16c-.16-.16-.39-.23-.55-.16,0-.16-.08-.31-.08-.39-.16.08-.31,0-.39-.16s-.08-.31-.08-.47c.08-1.09.08-2.26.47-3.35.08-.23.16-.47.16-.78,0-.55-.31-1.17-.23-1.71-.23.08-.39-.23-.39-.47s-.08-.55-.31-.62h-.23c-.23-.08-.16-.39-.08-.62.16-.55-.08-1.17-.08-1.79,0-.39.08-.86.08-1.25,0-1.17-.62-2.34-1.71-2.8-.08,0-.08-.08-.16-.08-.16,0-.23.16-.23.23-.23.39-.39.78-.62,1.17-.08.23-.23.39-.23.62,0,.16,0,.31.08.39.16.62.31,1.25.55,1.79.08.16.23.39.39.31-.08.47-.23,1.01-.47,1.4.16.55.31,1.09.23,1.64-.08.23-.16.47-.16.7-.31,1.25.08,2.57.47,3.82,0,.08.08.16.16.23.08.08.23.16.31.23.23.23.08.7.39.78-.16.23-.31.47-.31.78s.31.55.55.47c-.08.7,0,1.4.55,1.79.08-.08.16-.16.31-.16.08.16.16.23.23.39.39-.08.7.23.93.55.08,0,.16-.08.23-.08,1.32.31,2.96-1.01,3.97-.08.47.39.47,1.17.23,1.71s-.7,1.01-1.17,1.48c-.93.93-1.95,1.87-2.88,2.8-.78.7-1.56,1.48-2.57,1.71-.39.08-.78.08-1.17.16-.62.08-1.25.47-1.79.78-1.48.86-2.96,1.71-4.44,2.57-.39.23-.78.47-1.01.86-.31.55-.16,1.17-.08,1.71.23,2.73-1.87,5.53-4.59,6-.47.08-.93.08-1.32.39-.23.23-.39.55-.47.78-.31.86-.62,1.95-1.48,2.34-.39.23-.93.23-1.32.39-1.71.55-2.34,2.8-3.97,3.5-1.32.55-2.8-.08-3.89-.93-1.56-1.32-2.41-3.19-3.04-5.14-.47-1.4-.78-2.8-1.09-4.2-.39-1.71-.86-3.82-1.25-5.53.16-.47,0-1.01-.31-1.4,1.79-1.64,3.66-3.58,3.66-6,0-1.71-.86-3.35-.55-4.98.08-.55.31-1.01.31-1.48,0-.55-.16-1.17.08-1.71.23-.47.7-.62,1.01-1.01.86-.93.16-2.65-1.09-2.8-.39-.08-.78,0-1.09-.16-.78-.47-.08-1.95-.86-2.57-.55-.47-1.4.08-2.1.16-.93.08-1.79-.7-2.34-1.48s-.93-1.71-1.71-2.26c-.16-.16-.39-.23-.47-.39-.08-.23-.08-.47,0-.7.47-1.95.93-3.97,1.48-5.92.23-1.09.55-2.18,1.17-3.11.31-.47.7-.86,1.09-1.25.7-.86,1.25-1.79,1.87-2.73.7-.86,1.56-1.71,2.65-1.87,1.01-.23,2.18.08,3.04-.47.47-.31.78-.78,1.25-1.17,1.4-1.32,3.82-.86,5.61-.55,1.01.16,2.41.55,4.05,1.32.86,0,1.87.16,2.1.7.31.62-.39,1.17-.47,2.02-.16.93.47,2.26,3.43,4.2.08-.55,1.25-.7,1.64-.31.47.39.62.93,1.01,1.4.23.31.47.55.86.7,1.01.55,2.41.55,2.88,1.56.08.23.16.47.31.55.31.16.62-.16.78-.39s.62-.47.86-.23c.08.16.08.31.16.47.16.23.47.39.78.31.39-.08.62-.39.78-.47.39-.47,2.65-1.48,2.57-2.1-.08-.62-3.43-1.64-4.05-1.64-.16,0-.7.08-.93-.23-.16-.16-.16-.47-.16-.7,0-.47.08-1.01.31-1.4.08-.16.23-.23.31-.39.08-.23-.08-.39-.23-.55-.31-.39-.62-.78-1.01-1.01-.47-.23-1.01-.23-1.32.16-.23.31-.16.55-.39.86-.16.23-.39.7-1.01.23s.08-2.02.31-2.49c.08-.16.23-.39.23-.62,0-.55-.62-.93-.93-1.4-.23-.47-.23-1.01-.47-1.48-.23-.47-.86-.86-1.25-.47s0,1.01.23,1.48c.23.39.31.86.23,1.32-.08.7-.7,1.56-1.4,1.25-.47-.16-.62-.7-.62-1.17s.16-.93.23-1.4c.08-.55-.08-1.17-.39-1.64-.08-.16-.23-.31-.39-.31s-.31.08-.47.16c-1.09.55-2.34-.62-3.5-.47-.39.08-.78.23-1.17.39-1.09.47-2.34.55-3.5.7-.86.08-2.02,0-2.34-.78s.31-1.56.93-2.1c.47-.39.86-.86,1.32-1.25.31-.31.7-.62,1.17-.78s1.01-.08,1.25.31c.16.23.23.62.39.93.23.47.86.55,1.32.47.47-.08.78-.16,1.4-.55.31-.16.55-.31.7-.47,0,0,.08-.08.16-.16.16-.16.23-.16.31-.31.23-.23.08-.39.23-.62.16-.16.31-.23.39-.23.16,0,.31,0,.93.23.39.16.55.31.78.23.31-.08.39-.47.31-.7s-.31-.47-.55-.7c-.31-.31.23-.93.62-1.01.47-.08.86.08,1.32-.16s.7-.7,1.01-1.17c.31-.39.93-.78,1.32-.47,0,.62-.31,1.17-.78,1.48-.23.16-.55.31-.7.55-.16.23-.08.7.23.7-.31.39-.62,1.09-.23,1.4.16.16.39.16.47.16.78,0,1.56,0,2.34-.08.16,0,.39,0,.55.16.08.08.08.16.16.23.23.23.62-.23,1.01-.16,2.73.78-1.25-.86.55.86.16.16.47.16.7.16,1.4-.08,2.8-.31,4.2-.55.23-.08.47-.08.7-.16h1.95c.23,0,.55.08.62.31.08-.08.23-.16.31-.08,0-.23.31-.31.55-.23.23.08.47.23.7.16.31-.08.78-.78.62-1.01s-.55-.23-.86-.16c-.31.08-.55.23-.86.31-.47.08-.93-.31-1.32-.62-.08-.08-.23-.16-.23-.31-.08-.23.16-.47.39-.55.23-.08.55-.08.78-.16.23-.08.47-.31.39-.47-.08-.23-.39-.23-.55-.16-.39,0-.78.08-1.17.16-.31,0-.7-.08-1.01.16-.16.08-.31.31-.47.39-.23.23-.55.39-.86.47-.78.31-1.56.47-2.41.62h-.31c-.23-.16-.31-.62-.62-.62.23-.31.55-.62.78-.93,0-.08-.16-.16-.31-.16s-.23.08-.31.16c-.39.16-.78.08-1.01-.23-.08,0-.16-.16-.08-.31.78-.78,1.79-1.17,2.88-1.17.08,0,.23,0,.31.08s.16.16.23.16h.23c.23-.08.39.08.62.08h.39c.62-.08,1.01,0,1.71-.08.47.08.93.08,1.32-.16.47.47,1.25.23,1.87.39.62.16,1.09.55,1.64.78.39.08.78.08,1.17.16.39.08.47.55.62.86.16.16.16.47.39.55.08.08.16.08.23.08.23.16.16.47,0,.62s-.47.23-.7.16c-.23,0-.16-.39-.39-.39-.08.23-.08.47,0,.7.08.23,0,.7.23.7.31,0,.55-.23.78-.39.31-.23.78-.31,1.17-.23,1.32.16,2.73-.86,3.82-.08.23.16.39.31.62.39.55.23,1.25-.16,1.87.08.47.16.86.7,1.32.55.39-.16.47-.62.86-.7.39-.08.7.47,1.01.7.39.31,1.01.16,1.25-.23.08-.16.16-.31.31-.47.23-.16.55-.16.78,0s.39.39.55.55c.31.31,1.25.7,3.27.55",
    style: {
      fill: "url(#Unbenannter_Verlauf_76)",
      stroke: "url(#Unbenannter_Verlauf_77)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.68,204.94c-.39.47-.16,1.25.31,1.64s1.17.39,1.79.39c.39,0,.7-.08,1.01-.23.55-.31.78-.93,1.09-1.4.86-1.4,2.26-2.41,3.27-3.58.47-.55,1.32-1.48,1.01-2.26-.39-1.01-.93-.39-1.32.08-.93.86-1.4,1.01-2.73.86-1.09-.08-1.79-.23-2.34.86-.39.7-.78,1.48-1.09,2.18-.16.39-.08.62-.31,1.01-.08.16-.47.23-.7.47Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,196.14c.08.23.31.39.39.55.16.31.08.62.08.93-.16,1.17-.23,2.41-.55,3.58-.08.47-.23,1.01.16,1.32.39.31,1.01,0,1.25-.39.23-.47.31-.93.62-1.4.16-.23.39-.47.62-.7.16-.23.31-.62.16-.86-.16-.39-.78-.55-.78-.93,0-.31.23-.55.16-.86-.08-.16-.47-.39-.55-.7-.16-.55.23-1.17.08-1.71-.7-2.49-2.41-.23-1.64,1.17Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.49,193.73c.08.23.08.55.08.78,0,.62.08,1.17.31,1.71.08.16.16.31.39.39s.47-.23.47-.55-.16-.55-.23-.78-.08-.62.16-.78c.08-.08.23-.16.39-.16.39-.23.47-.78.23-1.09-.16-.23-.47-.31-.62-.47-.7-.55-.78-1.48-.47-2.26-.47,0-1.01.55-1.25.93-.78,1.17.16,1.32.55,2.26Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,189.05c-1.01.39-1.87,1.32-2.1,2.41-.16.55-.16,1.17-.23,1.71-.47,2.41-2.73,3.97-3.89,6.07-.08-.08.08-.16.16-.08.08.08,0,.16,0,.23-.16.47-.31,1.01-.39,1.48.7.55.93,1.64.55,2.49,1.32-1.87,2.49-3.97,3.35-6.07.47-1.17.93-2.34,1.4-3.58.47-1.56,1.17-3.11,1.17-4.67Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,204.71c-.47,0-1.01.16-1.4.47-.08.08-.23.16-.39.23-.16.08-.39,0-.55,0-.47,0-.7.55-.78,1.01-.23,1.09-.23,2.26-.78,3.27-.08-.08.08-.08.16-.23,1.56-1.4,2.8-2.96,3.74-4.75Z",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,177.37c-.16-.16-.39-.23-.55-.16,0-.16-.08-.31-.08-.39-.16.08-.31,0-.39-.16s-.08-.31-.08-.47c.08-1.09.08-2.26.47-3.35.08-.23.16-.47.16-.78,0-.55-.31-1.17-.23-1.71-.23.08-.39-.23-.39-.47s-.08-.55-.31-.62h-.23c-.23-.08-.16-.39-.08-.62.16-.55-.08-1.17-.08-1.79,0-.39.08-.86.08-1.25,0-1.17-.62-2.34-1.71-2.8-.08,0-.08-.08-.16-.08-.16,0-.23.16-.23.23-.23.39-.39.78-.62,1.17-.08.23-.23.39-.23.62,0,.16,0,.31.08.39.16.62.31,1.25.55,1.79.08.16.23.39.39.31-.08.47-.23,1.01-.47,1.4.16.55.31,1.09.23,1.64-.08.23-.16.47-.16.7-.31,1.25.08,2.57.47,3.82,0,.08.08.16.16.23.08.08.23.16.31.23.23.23.08.7.39.78-.16.23-.31.47-.31.78s.31.55.55.47c-.08.7,0,1.4.55,1.79.08-.08.16-.16.31-.16.08.16.16.23.23.39.39-.08.7.23.93.55.08,0,.16-.08.23-.08,1.32.31,2.96-1.01,3.97-.08.47.39.47,1.17.23,1.71s-.7,1.01-1.17,1.48c-.93.93-1.95,1.87-2.88,2.8-.78.7-1.56,1.48-2.57,1.71-.39.08-.78.08-1.17.16-.62.08-1.25.47-1.79.78-1.48.86-2.96,1.71-4.44,2.57-.39.23-.78.47-1.01.86-.31.55-.16,1.17-.08,1.71.23,2.73-1.87,5.53-4.59,6-.47.08-.93.08-1.32.39-.23.23-.39.55-.47.78-.31.86-.62,1.95-1.48,2.34-.39.23-.93.23-1.32.39-1.71.55-2.34,2.8-3.97,3.5-1.32.55-2.8-.08-3.89-.93-1.56-1.32-2.41-3.19-3.04-5.14-.47-1.4-.78-2.8-1.09-4.2-.39-1.71-.86-3.82-1.25-5.53.16-.47,0-1.01-.31-1.4,1.79-1.64,3.66-3.58,3.66-6,0-1.71-.86-3.35-.55-4.98.08-.55.31-1.01.31-1.48,0-.55-.16-1.17.08-1.71.23-.47.7-.62,1.01-1.01.86-.93.16-2.65-1.09-2.8-.39-.08-.78,0-1.09-.16-.78-.47-.08-1.95-.86-2.57-.55-.47-1.4.08-2.1.16-.93.08-1.79-.7-2.34-1.48-.55-.78-.93-1.71-1.71-2.26-.16-.16-.39-.23-.47-.39-.08-.23-.08-.47,0-.7.47-1.95.93-3.97,1.48-5.92.23-1.09.55-2.18,1.17-3.11.31-.47.7-.86,1.09-1.25.7-.86,1.25-1.79,1.87-2.73.7-.86,1.56-1.71,2.65-1.87,1.01-.23,2.18.08,3.04-.47.47-.31.78-.78,1.25-1.17,1.4-1.32,3.82-.86,5.61-.55,1.01.16,2.41.55,4.05,1.32.86,0,1.87.16,2.1.7.31.62-.39,1.17-.47,2.02-.16.93.47,2.26,3.43,4.2.08-.55,1.25-.7,1.64-.31.47.39.62.93,1.01,1.4.23.31.47.55.86.7,1.01.55,2.41.55,2.88,1.56.08.23.16.47.31.55.31.16.62-.16.78-.39s.62-.47.86-.23c.08.16.08.31.16.47.16.23.47.39.78.31.39-.08.62-.39.78-.47.39-.47,2.65-1.48,2.57-2.1-.08-.62-3.43-1.64-4.05-1.64-.16,0-.7.08-.93-.23-.16-.16-.16-.47-.16-.7,0-.47.08-1.01.31-1.4.08-.16.23-.23.31-.39.08-.23-.08-.39-.23-.55-.31-.39-.62-.78-1.01-1.01-.47-.23-1.01-.23-1.32.16-.23.31-.16.55-.39.86-.16.23-.39.7-1.01.23s.08-2.02.31-2.49c.08-.16.23-.39.23-.62,0-.55-.62-.93-.93-1.4-.23-.47-.23-1.01-.47-1.48-.23-.47-.86-.86-1.25-.47s0,1.01.23,1.48c.23.39.31.86.23,1.32-.08.7-.7,1.56-1.4,1.25-.47-.16-.62-.7-.62-1.17s.16-.93.23-1.4c.08-.55-.08-1.17-.39-1.64-.08-.16-.23-.31-.39-.31s-.31.08-.47.16c-1.09.55-2.34-.62-3.5-.47-.39.08-.78.23-1.17.39-1.09.47-2.34.55-3.5.7-.86.08-2.02,0-2.34-.78s.31-1.56.93-2.1c.47-.39.86-.86,1.32-1.25.31-.31.7-.62,1.17-.78s1.01-.08,1.25.31c.16.23.23.62.39.93.23.47.86.55,1.32.47.47-.08.78-.16,1.4-.55.31-.16.55-.31.7-.47,0,0,.08-.08.16-.16.16-.16.23-.16.31-.31.23-.23.08-.39.23-.62.16-.16.31-.23.39-.23.16,0,.31,0,.93.23.39.16.55.31.78.23.31-.08.39-.47.31-.7s-.31-.47-.55-.7c-.31-.31.23-.93.62-1.01.47-.08.86.08,1.32-.16s.7-.7,1.01-1.17c.31-.39.93-.78,1.32-.47,0,.62-.31,1.17-.78,1.48-.23.16-.55.31-.7.55-.16.23-.08.7.23.7-.31.39-.62,1.09-.23,1.4.16.16.39.16.47.16.78,0,1.56,0,2.34-.08.16,0,.39,0,.55.16.08.08.08.16.16.23.23.23.62-.23,1.01-.16,2.73.78-1.25-.86.55.86.16.16.47.16.7.16,1.4-.08,2.8-.31,4.2-.55.23-.08.47-.08.7-.16h1.95c.23,0,.55.08.62.31.08-.08.23-.16.31-.08,0-.23.31-.31.55-.23.23.08.47.23.7.16.31-.08.78-.78.62-1.01s-.55-.23-.86-.16c-.31.08-.55.23-.86.31-.47.08-.93-.31-1.32-.62-.08-.08-.23-.16-.23-.31-.08-.23.16-.47.39-.55.23-.08.55-.08.78-.16.23-.08.47-.31.39-.47-.08-.23-.39-.23-.55-.16-.39,0-.78.08-1.17.16-.31,0-.7-.08-1.01.16-.16.08-.31.31-.47.39-.23.23-.55.39-.86.47-.78.31-1.56.47-2.41.62h-.31c-.23-.16-.31-.62-.62-.62.23-.31.55-.62.78-.93,0-.08-.16-.16-.31-.16s-.23.08-.31.16c-.39.16-.78.08-1.01-.23-.08,0-.16-.16-.08-.31.78-.78,1.79-1.17,2.88-1.17.08,0,.23,0,.31.08s.16.16.23.16h.23c.23-.08.39.08.62.08h.39c.62-.08,1.01,0,1.71-.08.47.08.93.08,1.32-.16.47.47,1.25.23,1.87.39.62.16,1.09.55,1.64.78.39.08.78.08,1.17.16.39.08.47.55.62.86.16.16.16.47.39.55.08.08.16.08.23.08.23.16.16.47,0,.62s-.47.23-.7.16c-.23,0-.16-.39-.39-.39-.08.23-.08.47,0,.7.08.23,0,.7.23.7.31,0,.55-.23.78-.39.31-.23.78-.31,1.17-.23,1.32.16,2.73-.86,3.82-.08.23.16.39.31.62.39.55.23,1.25-.16,1.87.08.47.16.86.7,1.32.55.39-.16.47-.62.86-.7.39-.08.7.47,1.01.7.39.31,1.01.16,1.25-.23.08-.16.16-.31.31-.47.23-.16.55-.16.78,0s.39.39.55.55c.31.31,1.25.7,3.27.55",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.92,177.22c.47.23,1.25.08,1.4.55-.08,0,0,.08-.08.08,2.34-.86,4.98-1.17,7.48-.78.23,0,.47.08.7,0,.16-.08.31-.16.39-.23.86-.7,1.64-1.4,2.49-2.02.31-.31.7-.62.86-1.01.16-.47-.08-1.09-.39-1.48s-.78-.7-1.17-1.01c-.23-.16-.39-.31-.47-.55-.08-.31,0-.62,0-.93s-.39-.7-.62-.47c-.16.08-.23.39-.39.47s-.23.08-.39.08c-.62-.08-1.17-.16-1.79-.23-.39-.08-.47-.62-.31-.93.16-.39.31-.78.08-1.09-.08-.16-.23-.23-.31-.39-.08-.23-.08-.47-.08-.62-.08-.47-.39-.78-.39-1.25,0-.7,1.01-.93,1.56-.62.55.31.86,1.01,1.17,1.64.31.62.62,1.25,1.32,1.48.39.08.7.08,1.09.16s.78.31.78.7c0,.23-.16.47-.08.7,0,.16.08.23.16.31.31.47.7.93,1.25,1.17.39.16.86.23,1.25.23.47,0,.93.08,1.48.08.31,0,.62.08.78.31.08.16.16.31.23.39.16.16.31.23.55.31,1.17.39,2.02,1.48,2.1,2.73.08.86-.23,1.79.39,2.41.16.23.47.23.78.39.16.08.47.16.55,0,.16.31.62.23.93.08-.08.7-.16,1.4-.31,2.1-.08.47-.16.93-.16,1.32,0,1.01.16,2.02-.23,3.04.16.08.31.23.31.47,0,.16-.08.39-.08.55-.23,1.09.23,2.34-.39,3.27,0-.08.08-.08.16-.08s.08.16.08.16v1.09c.47,0,.78-.47.86-.86.16-.47.23-.93.62-1.17.39.7.47,1.56.08,2.26-.08.23-.23.39-.31.62-.08.23,0,.47.16.62.16.16.55,0,.55-.16.16-.08.16.23.31.31s.31-.08.39-.23c.62-1.17.7-2.49.55-3.82-.08-.47-.16-.93,0-1.4.23-.78,1.09-1.25,1.4-2.02.16-.31.16-.62.31-.86.47-.86,1.79-1.01,2.18-1.95-.08.08,0,.23.08.23,0-.39.31-.62.62-.86.31-.16.62-.31.86-.62.16-.23.23-.55.39-.78s.39-.47.7-.39c.16,0,.23.08.39.08.23,0,.31-.23.39-.39.16-.16.39-.23.47-.08q0,.08.08.16c.08,1.09.23,2.18.31,3.27,0,.23.08.47.23.55s.23,0,.39.08.08.31.08.39c-.08.47-.23.93-.31,1.4-.08.39-.16.86.23,1.09.31.16.78-.08,1.01.16.16.08.16.31.31.39.08.08.23,0,.31-.08h.16c.08,0,.16.08.23.08,0,1.01,0,2.1.08,3.11.16-.08.23.23.31.39.16.23.55.08.7-.08.23-.23.39-.47.7-.47.16,0,.08.23.16.31.08.16.23.23.39.16.16-.08.23-.23.31-.39.47-.93.31-2.1.08-3.11,0-.16-.08-.31-.16-.47-.08-.16-.16-.23-.23-.31-.16-.31-.08-.7-.08-1.01s-.08-.78-.39-.86c.47-.86,1.01-1.64,1.64-2.34,0,.16.16.16.31.16s.23-.08.31-.23c.23-.23.47-.39.7-.62.08-.08.23-.23.39-.23h.39c.16,0,.23-.16.39-.23.31-.31.7-.55,1.17-.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.68,204.94c-.39.47-.16,1.25.31,1.64s1.17.39,1.79.39c.39,0,.7-.08,1.01-.23.55-.31.78-.93,1.09-1.4.86-1.4,2.26-2.41,3.27-3.58.47-.55,1.32-1.48,1.01-2.26-.39-1.01-.93-.39-1.32.08-.93.86-1.4,1.01-2.73.86-1.09-.08-1.79-.23-2.34.86-.39.7-.78,1.48-1.09,2.18-.16.39-.08.62-.31,1.01-.08.16-.47.23-.7.47Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,196.14c.08.23.31.39.39.55.16.31.08.62.08.93-.16,1.17-.23,2.41-.55,3.58-.08.47-.23,1.01.16,1.32.39.31,1.01,0,1.25-.39.23-.47.31-.93.62-1.4.16-.23.39-.47.62-.7.16-.23.31-.62.16-.86-.16-.39-.78-.55-.78-.93,0-.31.23-.55.16-.86-.08-.16-.47-.39-.55-.7-.16-.55.23-1.17.08-1.71-.7-2.49-2.41-.23-1.64,1.17Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.49,193.73c.08.23.08.55.08.78,0,.62.08,1.17.31,1.71.08.16.16.31.39.39s.47-.23.47-.55-.16-.55-.23-.78-.08-.62.16-.78c.08-.08.23-.16.39-.16.39-.23.47-.78.23-1.09-.16-.23-.47-.31-.62-.47-.7-.55-.78-1.48-.47-2.26-.47,0-1.01.55-1.25.93-.78,1.17.16,1.32.55,2.26Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36,189.05c-1.01.39-1.87,1.32-2.1,2.41-.16.55-.16,1.17-.23,1.71-.47,2.41-2.73,3.97-3.89,6.07-.08-.08.08-.16.16-.08.08.08,0,.16,0,.23-.16.47-.31,1.01-.39,1.48.7.55.93,1.64.55,2.49",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.35,204.71c-.47,0-1.01.16-1.4.47-.08.08-.23.16-.39.23-.16.08-.39,0-.55,0-.47,0-.7.55-.78,1.01-.23,1.09-.23,2.26-.78,3.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.27,
    cy: 178.23,
    r: 46.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_10-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 268.29,
    y1: 88.76,
    x2: 438.57,
    y2: 88.76,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.43,
    y1: 173.9,
    x2: 353.43,
    y2: 3.63,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.21,
    y1: 148.99,
    x2: 413.65,
    y2: 28.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.65,
    y1: 148.99,
    x2: 293.21,
    y2: 28.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.43,
    cy: 88.76,
    r: 54.8,
    style: {
      fill: "url(#Unbenannter_Verlauf_42)",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M365.2,46.2c18.39,4.96,31.9,21.88,31.9,41.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "449.88 121.35 513.8 121.35 535.93 155.2 472.01 155.2",
    style: {
      fill: "#eb5b5e",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.29 155.2 449.88 121.35 472.01 155.2 472.01 242.64 427.29 242.64 427.29 155.2",
    style: {
      fill: "#232121",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.01 155.2 535.39 155.2 535.39 242.64 472.01 242.54 472.01 155.2",
    style: {
      fill: "#d6e8f4",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".8px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.92,
    y: 219.4,
    width: 15.27,
    height: 23.24,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.41,
    y: 197.85,
    width: 5.86,
    height: 14.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.13,
    y: 197.85,
    width: 5.86,
    height: 14.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 197.85,
    width: 5.86,
    height: 14.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.41,
    y: 173.39,
    width: 5.86,
    height: 14.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.13,
    y: 173.39,
    width: 5.86,
    height: 14.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 173.39,
    width: 5.86,
    height: 14.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.44,
    y: 152.35,
    width: 131.53,
    height: 90.29,
    transform: "translate(660.41 394.99) rotate(-180)",
    style: {
      fill: "#fef5bb",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.4 122.01 264.58 153.46 264.58 242.64 216.22 242.64 216.22 153.46 240.4 122.01",
    style: {
      fill: "#232121",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.72 153.74 395.69 153.74 395.41 121.87 240.4 121.87 264.72 153.74",
    style: {
      fill: "#eb5b5e",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.91,197.91v18.45s15.1,0,15.1,0v-18.45h0c0-4.19-3.35-7.55-7.55-7.55s-7.55,3.35-7.55,7.55",
    style: {
      fill: "#e1edd8",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.69,
    y: 216.22,
    width: 21.53,
    height: 3.63,
    transform: "translate(734.91 436.08) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.75,197.91v18.45s15.1,0,15.1,0v-18.45h0c0-4.19-3.35-7.55-7.55-7.55s-7.55,3.35-7.55,7.55",
    style: {
      fill: "#58b3e1",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.68,
    y: 216.22,
    width: 21.53,
    height: 3.63,
    transform: "translate(658.88 436.08) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.59,197.91v18.45s15.1,0,15.1,0v-18.45h0c0-4.19-3.35-7.55-7.55-7.55s-7.55,3.35-7.55,7.55",
    style: {
      fill: "#d6e7f4",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.38,
    y: 216.22,
    width: 21.53,
    height: 3.63,
    transform: "translate(582.28 436.08) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.29,
    y1: 123.55,
    x2: 258.15,
    y2: 140.32,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.6,
    y1: 221.53,
    x2: 218.6,
    y2: 155.14,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.8,
    y1: 236.91,
    x2: 267.8,
    y2: 186.31,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.59,
    y1: 149.97,
    x2: 391.64,
    y2: 149.97,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.44,
    y1: 190.5,
    x2: 329.44,
    y2: 216.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.85,
    y1: 207.42,
    x2: 321.75,
    y2: 207.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.85,
    y1: 198.89,
    x2: 321.75,
    y2: 198.89,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.14,
    y1: 190.5,
    x2: 291.14,
    y2: 216.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.55,
    y1: 207.42,
    x2: 283.59,
    y2: 207.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.55,
    y1: 198.89,
    x2: 283.59,
    y2: 198.89,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.46,
    y1: 190.5,
    x2: 367.46,
    y2: 216.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.87,
    y1: 207.42,
    x2: 359.91,
    y2: 207.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.87,
    y1: 198.89,
    x2: 359.91,
    y2: 198.89,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.57,
    y: 87.49,
    width: 48.36,
    height: 155.01,
    transform: "translate(837.51 329.99) rotate(-180)",
    style: {
      fill: "#fef5bb",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.08 87.49 418.75 40.81 394.71 87.49 443.08 87.49",
    style: {
      fill: "#eb5b5e",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.71,216.36l-.14,26.14h21.67s0-26.14,0-26.14h0c0-5.87-4.75-10.76-10.76-10.76-5.87,0-10.76,4.75-10.76,10.76",
    style: {
      fill: "#ab7152",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.61,
    y1: 205.46,
    x2: 418.61,
    y2: 242.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.93,163.25v18.45s15.1,0,15.1,0v-18.45h0c0-4.19-3.35-7.55-7.55-7.55s-7.55,3.35-7.55,7.55",
    style: {
      fill: "#58b3e1",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.71,
    y: 181.56,
    width: 21.53,
    height: 3.63,
    transform: "translate(836.95 366.75) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.93,103.42v18.45s15.1,0,15.1,0v-18.45h0c0-4.19-3.35-7.55-7.55-7.55s-7.55,3.35-7.55,7.55",
    style: {
      fill: "#d6e7f4",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.71,
    y: 121.73,
    width: 21.53,
    height: 3.63,
    transform: "translate(836.95 247.1) rotate(-180)",
    style: {
      fill: "#f9cabf",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.34,
    y1: 82.04,
    x2: 419.31,
    y2: 47.1,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.14,
    y1: 238.31,
    x2: 440.14,
    y2: 120.9,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 397.37,
    y1: 169.54,
    x2: 397.37,
    y2: 90.01,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.14,
    y1: 216.08,
    x2: 427.14,
    y2: 240.26,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.47,
    y1: 155.84,
    x2: 418.47,
    y2: 181.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.88,
    y1: 172.89,
    x2: 410.93,
    y2: 172.89,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.88,
    y1: 164.37,
    x2: 410.93,
    y2: 164.37,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.47,
    y1: 95.88,
    x2: 418.47,
    y2: 121.59,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.88,
    y1: 112.93,
    x2: 410.93,
    y2: 112.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.88,
    y1: 104.4,
    x2: 410.93,
    y2: 104.4,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.42 242.59 470.88 221.44 458.36 234.7 461.29 200.05 448.43 233.79 444.02 214.14 439.88 242.59 463.42 242.59",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.51,
    y1: 242.68,
    x2: 699.49,
    y2: 242.68,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.84,35.15v2.41c0,5.88,3.84,10.7,8.44,10.7h1.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.84,35.15v2.41c0,5.88-3.84,10.7-8.44,10.7h-1.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.84,61.45v-2.41c0-5.88,3.84-10.7,8.44-10.7h1.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.84,61.45v-2.41c0-5.88-3.84-10.7-8.44-10.7h-1.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,94.81v1.81c0,4.37,2.86,8.06,6.33,8.06h1.28",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,94.81v1.81c0,4.37-2.86,8.06-6.33,8.06h-1.28",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,114.48v-1.81c0-4.37,2.86-8.06,6.33-8.06h1.28",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,114.48v-1.81c0-4.37-2.86-8.06-6.33-8.06h-1.28",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.64,108.45v1.4c-.22,3.53,2.06,6.61,4.7,6.69h1.03",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.64,108.45v1.4c-.22,3.53-2.64,6.39-5.29,6.32h-1.03",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.06,124.39v-1.4c.22-3.53,2.64-6.39,5.29-6.32h1.03",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.06,124.39v-1.4c.22-3.53-2.06-6.61-4.7-6.69h-1.03",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.53,76.88v1.76c0,4.55,3.01,8.3,6.39,8.3h1.32",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.53,76.88v1.76c0,4.55-3.01,8.3-6.39,8.3h-1.32",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.53,97.16v-1.76c0-4.55,3.01-8.3,6.39-8.3h1.32",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.53,97.16v-1.76c0-4.55-3.01-8.3-6.39-8.3h-1.32",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.7,85.94c4.33,0,8.23-2.13,10.87-5.51h0c1.76-2.13,4.33-3.53,7.2-3.53s3.89.66,5.44,1.84l.15.15c1.69,1.4,3.75,2.2,5.95,2.2,5.36,0,9.77-4.78,9.77-10.65s-4.33-10.65-9.77-10.65-3.97.66-5.51,1.84h-.22c-1.62,1.47-3.67,2.28-5.88,2.28-3.16,0-5.95-1.62-7.79-4.19l.29.37c-.22-.22-.44-.44-.59-.66-2.57-2.72-6.02-4.41-9.92-4.41s-7.49,1.76-10.06,4.55l-.22.15c-1.76,2.5-4.63,4.19-7.79,4.19s-4.26-.81-5.88-2.13h-.22c-1.54-1.25-3.45-1.98-5.51-1.98-5.36,0-9.77,4.78-9.77,10.65s4.33,10.65,9.77,10.65,4.33-.81,5.95-2.2l.15-.15c1.54-1.1,3.45-1.84,5.44-1.84s5.44,1.32,7.2,3.45h0c2.57,3.38,6.46,5.51,10.87,5.51s8.67-2.35,11.31-6.1",
    style: {
      fill: "#d6e8f4",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.9,70.59c0,4.41,3.23,7.93,7.27,7.93s3.23-.59,4.48-1.62h.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.56,61.4l.22.29c-.15-.15-.29-.37-.51-.51-2.06-2.2-4.85-3.53-7.93-3.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.38,78.3c3.97,0,7.2-3.53,7.2-7.86",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_13-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195.63 169.27 249.6 169.72 264.94 195.79 210.18 195.93 195.63 169.27",
    style: {
      fill: "#eb5b5e",
      stroke: "#020202",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 195.63,
    y1: 169.27,
    x2: 249.69,
    y2: 169.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.61 195.56 195.63 169.27 210.18 195.93 209.82 242.49 180.61 242.48 180.61 195.56",
    style: {
      fill: "#232121",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.82,
    y: 196.02,
    width: 54.96,
    height: 46.47,
    style: {
      fill: "#e0edd8",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.98,
    y: 217.72,
    width: 15.1,
    height: 24.23,
    style: {
      fill: "#40abe1",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.23,
    y: 211.12,
    width: 7.59,
    height: 12.66,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.88,
    y: 211.12,
    width: 7.59,
    height: 12.66,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.97,
    y: 158.69,
    width: 7.59,
    height: 10.12,
    style: {
      fill: "#e0edd8",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.79,
    y1: 195.48,
    x2: 250.14,
    y2: 169.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.31 242.49 201.14 218.98 191.8 237.27 188.14 223.65 186.27 238.44 173.27 217.81 177.07 236.54 169.62 228.48 174.83 242.49 196.31 242.49",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.58,
    y: 114.58,
    width: 5.68,
    height: 128.06,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.45,125.08l18.32,8.92-18.47,8.92c-.87,0-1.82.39-2.84.39-4.97,0-9.24-4.11-9.24-9.24s4.11-9.24,9.24-9.24,1.42,0,3,.39",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.77,
    y1: 134.01,
    x2: 588.98,
    y2: 134.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.53,193.61l-11.84,5.68,11.92,5.68c.55.08,1.11.24,1.82.24,3.32,0,5.92-2.76,5.92-5.92s-2.76-5.92-5.92-5.92-1.03,0-1.89.24",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.69,
    y1: 199.22,
    x2: 582.58,
    y2: 199.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.11,96.11l.47-17.76,1.82-4.5,1.34-1.18c.63-.47,1.5,0,2.37,0l.87.32,1.97,4.03.47,4.03.63-4.34c0-.63.32-1.34.87-1.82l2.37-2.53h.63c.87.32,1.82.47,2.37,1.18l1.34,2.84,1.03,3.87v1.18l1.18-5.21,1.66-3.16,1.82-.47,2.21.47,1.5,2.37.87,4.34.32,1.5,1.34-5.68c0-.47.32-.87.47-1.18l1.18-1.5.87-.47c.87-.16,1.82,0,2.53.63l1.18,1.5,1.03,2.84.32,2.53v16.42c0,.16-.32,4.03-.32,4.18l-.87,2.53-2.84,4.66c-.63,1.03-2.84,3.16-3.87,3.71l-3.32,1.82-4.82,1.5h-5.84c0-.16-4.82-1.66-4.82-1.66l-3.87-2.53c-1.66-1.5-3.87-3.87-4.66-6l-1.66-5.53v-2.84h0l-.16-.08Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.05,96.58c0,10.03-8.37,18.4-18.4,18.4s-18.55-8.37-18.55-18.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.5,81.74c0-5.05-1.97-9.39-4.5-9.39s-4.5,4.18-4.5,9.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.5,81.74c0-5.05,1.97-9.39,4.5-9.39s4.5,4.18,4.5,9.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.82,81.74c0-5.05,1.97-9.39,4.5-9.39s4.5,4.18,4.5,9.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.05,81.74c0-5.05,1.97-9.39,4.5-9.39s4.5,4.18,4.5,9.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 567.42,
    y1: 81.74,
    x2: 567.11,
    y2: 96.58,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 604.05,
    y1: 96.58,
    x2: 604.05,
    y2: 81.74,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 585.82,
    y1: 81.74,
    x2: 585.82,
    y2: 62.64,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.66,64.85c.87,2.37,1.5,4.5,1.5,7.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 585.82,
    cy: 60.5,
    r: 2.37
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.11,
    cy: 63.98,
    r: 2.37
  })), /*#__PURE__*/React.createElement("path", {
    d: "M591.5,64.85c-.87,2.37-1.5,4.5-1.5,7.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 592.21,
    cy: 63.98,
    r: 2.37
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "610.73 190.68 616.75 190.68 606.89 242.64 600.87 242.64 610.73 190.68",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.01,212.65l13.45,10.27-16.54,4.18c-.75-.17-1.5,0-2.34-.17-4.09-.84-6.85-4.84-6.01-9.02s4.84-6.85,9.02-6.01c4.18.84,1.17.25,2.42.75",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 636.46,
    y1: 222.93,
    x2: 611.4,
    y2: 217.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.95,177.65l.39-2.56c1.23-9.19,9.62-15.52,18.65-14.32,9.03,1.2,15.52,9.62,14.32,18.65l-.39,2.56",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614.44,
    cy: 179.81,
    r: 16.62,
    style: {
      fill: "#fff7bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614.44,
    cy: 179.81,
    r: 13.87,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "615 170.52 618.06 170.98 615.85 189.4 612.55 188.9 614.3 176.24",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "614.14 176.22 611.25 179.66 608.79 177.52 615 170.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.29,68.13v2c0,5.18,3.42,9.44,7.27,9.44h1.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.29,68.13v2c0,5.18-3.42,9.44-7.27,9.44h-1.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.29,91.18v-2c0-5.18,3.42-9.44,7.27-9.44h1.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.29,91.18v-2c0-5.18-3.42-9.44-7.27-9.44h-1.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "139.66 192.56 145.79 192.56 145.79 189.64 148.65 189.62 149.82 189.02 150.41 187.97 150.47 184.3 151.32 184.24 151.81 183.35 151.11 182.52 150.47 181.62 150.47 180 150.32 178.98 149.97 177.84 149.54 177.25 148.65 178.5 147.66 179.26 146.42 180.07 144.64 180.63 143.32 180.76 142.34 180.76 141.51 181.45 141.26 182.02 141.21 182.61 141.34 183.14 141.83 183.82 142.58 184.22 143.62 184.28 143.82 185.64 143.54 187.49 143.1 188.72 142.13 190.28 141.07 191.21 139.66 192.56",
    style: {
      fill: "#fef5b9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.73 210.45 163.98 236.19 165.11 236.63 165.55 236.19 166.38 236.18 166.87 235.7 167.16 235.33 167.88 235.55 168.51 235.54 168.82 235.01 168.82 233.69 169.71 233.44 169.86 233.08 169.86 232.51 168.59 228.21 167.88 227.71 166.72 227.64 161.73 210.37 156.73 210.45",
    style: {
      fill: "#fff6b7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.74 210.39 128.73 210.47 122.36 233.47 121.37 233.78 120.73 233.08 121.67 229.49 112.45 235.39 111.77 234.65 111.77 234.03 110.91 234.03 110.68 233.08 113.86 230.76 110.81 230.82 109.9 230.08 110.56 229.19 111.77 229.18 116.29 229.11 118.59 227.61 123.74 210.39",
    style: {
      fill: "#fff6bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18,174.69c-.46-.27-2.03-1.09-4.11-.83-1.52.19-2.59.88-3.1,1.26-.4.3-1.1.89-1.69,1.86-.16.26-.5.87-.73,1.72-.3,1.1-.08,1.37-.29,2.68-.09.53-.24,1.46-.76,2.51-.51,1.05-1.15,1.74-1.5,2.08-.39.38-1.16,1.13-2.37,1.59-1.33.5-1.62.06-3.55.62-1.29.38-1.82.76-2.14,1.09-.16.16-.59.62-.87,1.37-.14.39-.32,1.08-.19,1.92.16,1.02.69,1.64,1.06,2.08.35.42.68.81.98.73.33-.08.24-.59.72-1.28.59-.84,1.48-1.14,1.71-1.23.24-.08.45-.12.85-.18,1.16-.15,2.08-.13,2.58-.12,0,0,1.81.03,3.98,0,.6,0,1.09-.02,1.4-.04l1.43-.78,1.21-1.17,1.31-1.88.6-2.77-.07-1.68-1.05-.06-1.24-1.09-.08-1.11.25-.56,1.24-.81.95-.02h.94s1.78-.55,1.78-.55l1.25-.81,1.25-1.09.63-.94-.78-1.29-1.1-.97-.49-.3h0Z",
    style: {
      fill: "#944722"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.79 189.64 148.19 189.64 148.19 190.91 147.73 192.33 146.12 192.52 145.79 192.56 145.79 189.64",
    style: {
      fill: "#944722"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.74 210.39 131.84 210.39 131.92 225.05 153.57 225.05 153.63 210.37 161.73 210.37 157.69 195.87 157 194.5 155.22 193.02 152.87 192.58 133.77 192.58 130.34 192.89 128.63 194.1 127.74 196.04 123.74 210.39",
    style: {
      fill: "#e1edd8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.26 264.84 129.27 264.84 142.78 227.81 157.27 267.8 166.51 262.67 153.07 225.05 132.74 225.04 118.26 264.84",
    style: {
      fill: "url(#Unbenannter_Verlauf_43)",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.98 266.89 128.36 266.96 129.27 264.84 123.64 264.87 122.98 266.89",
    style: {
      fill: "#fff6b7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.78 265.29 162.7 267.27 167.31 264.63 166.51 262.67 161.78 265.29",
    style: {
      fill: "#fff6b7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.98 266.89 128.36 266.96 137.1 269.48 137.96 270.33 137.96 271.39 137.53 272.26 136.74 272.68 120.78 272.74 122.98 266.89",
    style: {
      fill: "#f6b5b3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.7 267.27 167.31 264.63 175.48 262.57 176.74 262.63 177.52 263.29 177.71 263.95 177.53 264.97 164.66 272.92 162.7 267.27",
    style: {
      fill: "#f6b5b3"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "153.57 196.44 153.57 225.05 131.92 225.05 131.92 196.44",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.03,
    y1: 192.58,
    x2: 153.57,
    y2: 192.58,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.97,192.58c-.41.03-1.65.17-2.77,1.14-1.18,1.03-1.48,2.31-1.55,2.7-2.84,9.82-6.23,21.41-9.07,31.23",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "128.73 210.47 123.75 228.2 122.37 233.1",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.74,
    y1: 210.39,
    x2: 131.84,
    y2: 210.39,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.54,
    y1: 211.94,
    x2: 126.84,
    y2: 211.94,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.34,
    y1: 212.82,
    x2: 126.64,
    y2: 212.82,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.36,233.15c-.1.45-.54.72-.98.63s-.72-.54-.63-.98",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.78,
    y1: 232.71,
    x2: 121.76,
    y2: 229.18,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "110.91 232.7 118.59 227.66 121.67 227.66",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "116.51 231 115.88 231.42 112.01 233.96",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "121.47 229.72 117.02 232.64 113.15 235.2",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.85,
    y1: 202.98,
    x2: 129.74,
    y2: 197.24,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.47,192.58c.41.03,1.65.17,2.77,1.14,1.18,1.03,1.48,2.31,1.55,2.7,2.84,9.82,6.23,21.41,9.07,31.23",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "156.73 210.45 161.71 228.18 163.08 233.08",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.73,
    y1: 210.37,
    x2: 153.63,
    y2: 210.37,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.92,
    y1: 211.92,
    x2: 158.63,
    y2: 211.92,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.12,
    y1: 212.8,
    x2: 158.83,
    y2: 212.8,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.62,
    y1: 202.96,
    x2: 155.73,
    y2: 197.23,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,228.81c-.25-.88-1.15-1.38-2.03-1.13",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,232.73c-.11-.44-.57-.7-1.01-.58s-.7.57-.58,1.01l.82,2.88c.13.44.59.69,1.03.55s.69-.59.55-1.03l-.81-2.85h0Z",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.32,232.27c-.11-.44-.57-.7-1.01-.58s-.7.57-.58,1.01l.82,2.88c.13.44.59.69,1.03.55s.69-.59.55-1.03l-.81-2.85h0Z",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.01,231.8c-.11-.44-.57-.7-1.01-.58s-.7.57-.58,1.01l.82,2.88c.13.44.59.69,1.03.55s.69-.59.55-1.03l-.81-2.85h0Z",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,230.31l.82,2.88c.13.44.59.69,1.03.55s.69-.59.55-1.03l-1.1-3.89",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.59,230.28c-.88.25-1.78-.26-2.03-1.13",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,192.56h6.22s0-2.92,0-2.92h2.59c1.09,0,1.97-.89,1.97-1.97v-3.37h.76",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,180.39c0-3.64-2.95-6.59-6.59-6.59-3.64,0-6.59,2.95-6.59,6.59",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.01,184.3c.45,0,.82-.37.82-.82,0-.23-.1-.43-.24-.58",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.51,182.85c-.98-.65-1.06-1.59-1.04-2.47",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.74,188.13c4.16.03,7.55-3.45,7.58-7.76",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,195.39c-1.24-.64-2.08-1.92-2.08-3.42,0-2.12,1.72-3.84,3.84-3.84",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15,192.54c.11-.05.23-.1.34-.15,2.93-1.39,4.75-4.65,4.25-8.15",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,184.15c-.21.09-.44.13-.67.13-1,0-1.81-.82-1.81-1.83s.81-1.83,1.81-1.83c.21,0,.41.04.6.1.02,0,.04,0,.06.02",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.66,192.52c.32-.87.51-1.81.52-2.79",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.54,177.19c-1.09,2.12-3.3,3.57-5.85,3.57",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.64,177.19c-.15,1.33-.49,1.95-1.46,3.02",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,177.68c-.76.89-1.74,1.56-2.87,1.95",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.65,185.2c.49.49,1.02.88,1.6,1.17",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 181.52,
    r: 0.44,
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "132.74 225.04 131.86 227.45 118.26 264.84 129.27 264.84",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "142.78 227.81 128.7 266.65 128.01 268.52",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "120.17 264.75 133.78 227.34 134.61 225.07",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.55,
    y1: 261.58,
    x2: 130.56,
    y2: 261.58,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,264.87l-2.86,7.85h15.54s.08,0,.08,0c.97-.04,1.71-.83,1.71-1.71,0-.77-.58-1.48-1.39-1.67-2.69-.79-5.39-1.59-8.07-2.38-1.88-.02-3.78-.05-5.66-.07",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.32,
    y1: 271.65,
    x2: 137.82,
    y2: 271.65,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.01,
    y1: 267.37,
    x2: 129.3,
    y2: 269.24,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.35,
    y1: 267.76,
    x2: 130.66,
    y2: 269.63,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.73,
    y1: 268.18,
    x2: 132.04,
    y2: 270.05,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.41,
    y1: 262.28,
    x2: 167.35,
    y2: 264.85,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "158.9 266.72 145.63 230.24 144.53 227.23",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.31,
    y1: 264.63,
    x2: 167.66,
    y2: 266.59,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.66,272.92l12.19-7.23.06-.05c.82-.52,1.06-1.59.61-2.35-.4-.67-1.26-.99-2.05-.72-2.72.69-5.44,1.37-8.17,2.06-1.53.89-3.07,1.76-4.61,2.65",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.28,
    y1: 271.88,
    x2: 177.71,
    y2: 263.95,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.69,
    y1: 264.28,
    x2: 169.04,
    y2: 266.25,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.05,
    y1: 263.93,
    x2: 170.4,
    y2: 265.9,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.45,
    y1: 263.6,
    x2: 171.8,
    y2: 265.56,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.89,
    y1: 265.29,
    x2: 164.66,
    y2: 272.92,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.51,
    y1: 262.67,
    x2: 157.27,
    y2: 267.8,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.39,
    y1: 259.57,
    x2: 156.36,
    y2: 264.76,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.79,
    y1: 227.81,
    x2: 146.25,
    y2: 226.51,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.98,190.1c1.14-1.19,1.88-2.81,1.97-4.62",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35,186.37c2.91,1.11,6.11.24,8.19-1.97.69-.73,1.26-1.62,1.64-2.63",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "116.24 229.11 115.31 229.12 110.68 229.17",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94,234c-.35.29-.87.23-1.15-.12s-.23-.87.12-1.15",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.15,235.17c-.35.29-.87.23-1.15-.12s-.23-.87.12-1.15",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86,230.82c-.45.05-.86-.28-.9-.72s.28-.86.72-.9",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.81,
    y1: 230.76,
    x2: 110.91,
    y2: 230.82,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 152.31,
    y1: 226.48,
    x2: 163.28,
    y2: 256.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.49,
    y1: 233.02,
    x2: 128.67,
    y2: 262.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.99,
    y1: 214.43,
    x2: 165.19,
    y2: 225.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.31,
    y1: 201.64,
    x2: 152.31,
    y2: 222.97,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.17,225.87c.03-.09,3.35-11.53,3.35-11.53",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.15,193.24c-.23-.43-.36-.91-.36-1.43,0-1.67,1.35-3.02,3.02-3.02",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.58,178.43c.69-2.38,2.93-3.95,5.31-3.62",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.56,224.3h-6.27s-.24-1.85-.24-1.85l-1.93-.24-1.12-.65-.4-.8.08-3.54-1.68-.08,1.53-3.62.72-2.73.8.89,1.68,1.37,2.01.89s1.45-.08,1.68-.16,1.37.56,1.37.56c0,0,.72,1.21.65,1.45s-.72,1.21-.96,1.28-1.53.4-1.53.16c0-.24.49,1.68.49,1.68l.96,1.61,1.61,1.05.72.4-.16,2.33h0Z",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.54,207.57l1.55.79,1.47,1.27.91,1.47.51,1.63v1.87s-1.03,3.46-1.03,3.46l-.84,2.74-.4,1.18-1.63-1.1-1.11-.95-.56-1-.49-1.68,1.09.07,1.03-.99.36-.99-.63-.98-.96-.61-1.03.12-1.39-.12-1.68-.69-1.68-1.37-.51-1.32.64-1.15,1.5-1.19,1.43-.55s1.35-.31,1.47-.28,1.98.4,1.98.4h0Z",
    style: {
      fill: "#fef5bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.34,282.92l-2.05,6.94v-.07c-.49,1.68-2.27,2.65-3.95,2.15l-3-.89c.1-.25.18-.5.27-.77.09-.28.16-.53.24-.79.92.28,1.85.55,2.77.83h-.04c.95.27,1.95-.28,2.24-1.23l-.05.12,1.99-6.75",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.59,
    cy: 276.41,
    r: 19.78,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.59,
    cy: 276.35,
    r: 17.65,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.59,
    y1: 258.71,
    x2: 506.59,
    y2: 294,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 524.24,
    y1: 276.35,
    x2: 488.94,
    y2: 276.35,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 519.07,
    y1: 263.88,
    x2: 494.11,
    y2: 288.83,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 519.07,
    y1: 288.83,
    x2: 494.11,
    y2: 263.88,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 522.9,
    y1: 269.6,
    x2: 490.3,
    y2: 283.11,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.35,
    y1: 292.66,
    x2: 499.84,
    y2: 260.06,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.84,
    y1: 292.66,
    x2: 513.35,
    y2: 260.06,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.3,
    y1: 269.6,
    x2: 522.9,
    y2: 283.11,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.6,
    cy: 276.28,
    r: 5.22,
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.91,
    y: 250.37,
    width: 1.64,
    height: 37.35,
    transform: "translate(949.46 538.1) rotate(-180)",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.15,
    y: 275.55,
    width: 12.14,
    height: 1.64,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.64,253.77v-22.04c0-3.29-1.94-6.14-4.75-7.44l-6.84-.03c-2.84,1.29-4.81,4.15-4.81,7.46v22s16.4.08,16.4.08",
    style: {
      fill: "#e1edd8",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.85,
    y: 250.53,
    width: 1.64,
    height: 6.91,
    transform: "translate(1011.34 507.96) rotate(-180)",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.05,250.58h3.45c0-.92-.75-1.67-1.67-1.67h-1.83s.93,0,.93,0h-30.18c-.92,0-1.67.75-1.67,1.67h33.14",
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.96,228.16c-.94-.2-1.88-.39-2.84-.59h.04c-.97-.19-1.92.44-2.12,1.41l.04-.12-7.46,36.6-1.61-.32,7.5-36.77v.07c.35-1.72,2.03-2.84,3.75-2.48l3.06.63c-.07.26-.13.51-.2.79-.07.28-.12.55-.17.81h0Z",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.59,
    y: 227.01,
    width: 10.57,
    height: 2.83,
    transform: "translate(993.56 557.06) rotate(-168.48)",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.25,261.55h31.4s0-7.79,0-7.79h-34.37s.09-.03.09-.03c-2.66,0-4.86,1.88-5.38,4.38l-.05.17-7.01,24.3,8.1,2.33,6.76-23.43",
    style: {
      fill: "#eb5b5e",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,282.37c-1.14-.1-2.1.4-2.41,1.48-.3,1.08.21,2.19,1.28,2.51l12.18,3.59,1.74-5.9-5.14-1.51c-2.55-.06-5.1-.11-7.64-.17h0Z",
    style: {
      fill: "#b27a61",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.62,
    y1: 288.81,
    x2: 450.91,
    y2: 284.77,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460.79,
    y1: 282.55,
    x2: 461.83,
    y2: 284.45,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.88,
    y1: 282.57,
    x2: 459.92,
    y2: 284.47,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.98,
    y1: 282.53,
    x2: 458.02,
    y2: 284.43,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 455.09,
    y1: 282.47,
    x2: 456.12,
    y2: 284.37,
    style: {
      fill: "none",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.69,
    cy: 287.73,
    r: 7.19,
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.72,
    cy: 287.74,
    r: 5.22,
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.19,
    y1: 278.23,
    x2: 470.29,
    y2: 280.56,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.55,
    y: 288.43,
    width: 12.98,
    height: 2.16,
    transform: "translate(817.31 697.16) rotate(-163.55)",
    style: {
      fill: "#fff",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.41 207.75 494.86 208.46 493.69 209.75 493.37 210.54 494.16 211.82 495.67 212.9 498.45 213.92 500.13 213.98 501.13 214.84 501.24 216.08 500.51 216.91 498.75 217.14 499.76 218.76 501.36 219.68 502.62 220.15 503.75 219.79 504.95 213.95 504.78 211.71 503.91 210.04 502.42 208.45 500.74 207.64 498.28 207.36 496.41 207.75",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.03,224.16v-1.8s-1.6,0-1.6,0c-1.04,0-1.88-.86-1.88-1.89v-3.23s-1.65,0-1.65,0l1.54-3.73",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.45,213.5c-.03-3.47,2.86-6.33,6.31-6.27,3.46.06,6.45,3.15,6.29,6.63-.39,2.71-1.7,5.71-2.3,8.03v2.22",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.93,217.12c.2.08.42.12.64.12.95,0,1.73-.77,1.73-1.74s-.77-1.74-1.72-1.75c-.2,0-.39.04-.57.1-.02,0-.04,0-.06.02",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.35,210.45c1.04,2.03,3.15,3.42,5.58,3.43",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.26,210.7c.14,1.27.46,1.87,1.38,2.88",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.59,210.93c.72.85,1.67,1.49,2.73,1.87",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.41,218.36c-.54.37-1.11.64-1.7.82",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494.28,
    cy: 214.55,
    r: 0.38,
    style: {
      fill: "#181716"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.86,217.1c.25,2.03,1.65,3.92,3.81,4.83",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.12,218.38c.43.83,1.07,1.57,1.87,2.16",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.65,
    y1: 221.08,
    x2: 497.27,
    y2: 221.98,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 493.15,
    y1: 268.35,
    x2: 489.76,
    y2: 264.61,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.39,261.81c-.53,1.03-.28,2.26.55,2.99",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.17,265.05s3.09,3.41,3.12,3.45c.24.26.65.28.91.04.26-.24.28-.65.04-.91-1.02-1.12-2.04-2.25-3.06-3.37",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.25,267.62c.24.26.65.28.91.04s.28-.65.04-.91l-1.55-1.71",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.15,263.39l3.06,3.36c.24.26.65.28.91.04s.28-.65.04-.91c-.82-.89-1.66-1.78-2.45-2.69-.69-.8-.52-1.1-.03-1.95.42-.72.62-1.53.38-2.36",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.42,
    y1: 257.45,
    x2: 489.34,
    y2: 261.85,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.93,244.48c.41-.7.64-1.52.64-2.4v-12.62c0-2.22-1.8-4.01-4.01-4.01s-4.01,1.8-4.01,4.01v11.98s-.03.04-.03.04l-6.87,14.8,7.27,3.36,6.56-14.18.41-.89",
    style: {
      fill: "#e1edd8",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.04,265.19c-.07.29-.13.57-.3.81s-.47.4-.74.33c-.3-.07-.49-.38-.51-.69s.07-.6.16-.89c.15-.45.3-.89.45-1.34",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.86,
    y: 261.57,
    width: 19.19,
    height: 5.41,
    transform: "translate(968.9 528.54) rotate(-180)",
    style: {
      fill: "url(#Unbenannter_Verlauf_72)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.15,
    y: 275.55,
    width: 12.14,
    height: 1.64,
    style: {
      fill: "url(#Unbenannter_Verlauf_72-2)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.85,
    y: 250.53,
    width: 1.64,
    height: 6.91,
    transform: "translate(1011.34 507.96) rotate(-180)",
    style: {
      fill: "url(#Unbenannter_Verlauf_71)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.96,228.16c-.94-.2-1.88-.39-2.84-.59h.04c-.97-.19-1.92.44-2.12,1.41l.04-.12-7.46,36.6-1.61-.32,7.5-36.77v.07c.35-1.72,2.03-2.84,3.75-2.48l3.06.63c-.07.26-.13.51-.2.79-.07.28-.12.55-.17.81h0Z",
    style: {
      fill: "url(#Unbenannter_Verlauf_70)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.59,
    y: 227.01,
    width: 10.57,
    height: 2.83,
    transform: "translate(993.56 557.06) rotate(-168.48)",
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.34,282.92l-2.05,6.94v-.07c-.49,1.68-2.27,2.65-3.95,2.15l-3-.89c.1-.25.18-.5.27-.77.09-.28.16-.53.24-.79.92.28,1.85.55,2.77.83h-.04c.95.27,1.95-.28,2.24-1.23l-.05.12,1.99-6.75",
    style: {
      fill: "#d6e7f4",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.59,
    cy: 276.41,
    r: 19.78,
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.59,
    cy: 276.35,
    r: 17.65,
    style: {
      fill: "url(#Unbenannter_Verlauf_69)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.59,
    y1: 258.71,
    x2: 506.59,
    y2: 294,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 524.24,
    y1: 276.35,
    x2: 488.94,
    y2: 276.35,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 519.07,
    y1: 263.88,
    x2: 494.11,
    y2: 288.83,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 519.07,
    y1: 288.83,
    x2: 494.11,
    y2: 263.88,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 522.9,
    y1: 269.6,
    x2: 490.3,
    y2: 283.11,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.35,
    y1: 292.66,
    x2: 499.84,
    y2: 260.06,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.84,
    y1: 292.66,
    x2: 513.35,
    y2: 260.06,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.3,
    y1: 269.6,
    x2: 522.9,
    y2: 283.11,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506.6,
    cy: 276.28,
    r: 5.22,
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.91,
    y: 250.37,
    width: 1.64,
    height: 37.35,
    transform: "translate(949.46 538.1) rotate(-180)",
    style: {
      fill: "#d6e7f4",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.05,250.58h3.45c0-.92-.75-1.67-1.67-1.67h-1.83s.93,0,.93,0h-30.18c-.92,0-1.67.75-1.67,1.67h33.14",
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.69,
    cy: 287.73,
    r: 7.19,
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.72,
    cy: 287.74,
    r: 5.22,
    style: {
      fill: "url(#Unbenannter_Verlauf_69-2)",
      stroke: "#171715",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.55,
    y: 288.43,
    width: 12.98,
    height: 2.16,
    transform: "translate(817.31 697.16) rotate(-163.55)",
    style: {
      fill: "#000001",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_19"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "491.18 257.69 489.17 262.27 488.84 263.95 488.47 265.92 489.25 266.33 490.1 265.02 491.89 267.03 493.49 268.63 494.31 268.37 494.53 267.81 495.32 267.37 495.46 266.89 496.21 266.44 496.14 265.73 493.46 262.98 493.38 262.04 493.86 260.82 494.24 259.85 494.12 258.81 491.18 257.69",
    style: {
      fill: "#fdf2e7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_18"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 493.15,
    y1: 268.35,
    x2: 489.76,
    y2: 264.61,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.41,261.74c-.53,1.03-.49,2.12.34,2.86",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.17,265.05s3.09,3.41,3.12,3.45c.24.26.65.28.91.04.26-.24.28-.65.04-.91-1.02-1.12-2.04-2.25-3.06-3.37",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.25,267.62c.24.26.65.28.91.04s.28-.65.04-.91l-1.55-1.71",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.15,263.39l3.06,3.36c.24.26.65.28.91.04s.28-.65.04-.91c-.82-.89-1.66-1.78-2.45-2.69-.69-.8-.52-1.1-.03-1.95.42-.72.62-1.53.38-2.36",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.42,
    y1: 257.45,
    x2: 489.34,
    y2: 261.85,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.93,244.48c.41-.7.64-1.52.64-2.4v-12.62c0-2.22-1.8-4.01-4.01-4.01s-4.01,1.8-4.01,4.01v11.98s-.03.04-.03.04l-6.87,14.8,7.27,3.36,6.56-14.18.41-.89",
    style: {
      fill: "#e1edd8",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.04,265.19c-.07.29-.13.57-.3.81s-.47.4-.74.33c-.3-.07-.49-.38-.51-.69s.07-.6.16-.89c.15-.45.3-.89.45-1.34",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 468.93,
    y1: 258.9,
    x2: 462.52,
    y2: 281.08,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 496.61,
    y1: 229.67,
    x2: 496.61,
    y2: 239.99,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.03,
    y1: 245.79,
    x2: 495.47,
    y2: 257.77,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.79,225.46c-1.68,1.03-2.94,2.76-3.39,4.68",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.07,240.14l-1.09-.63-.69-.53-.41-.82-.34-1.41-.5,1.48-.66,1.01-.78.53-.85.31c-.07.12.97.78.97.78l.75.66.56.91.31,1.35.63-1.67.78-1.04.72-.41.6-.53h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.49,235.12v.95c-.02,2.32-1.59,4.19-3.48,4.18h-.7",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.49,235.12v.95c0,.67.11,1.29.34,1.85.17.42.39.8.66,1.12.37.46.84.81,1.35,1.02.34.14.7.22,1.09.22h.7",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.43,245.4v-.95c.02-2.32-1.53-4.2-3.44-4.21h-.7",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.43,245.4v-.95c.02-2.32,1.59-4.19,3.48-4.18h.7",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_27"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "541.17 210.17 563.14 178.5 564.11 175.66 564.33 173.59 564.11 171.12 563.17 168.57 561.86 166.26 560.21 164.56 558.24 163.24 556.12 162.4 553.77 161.92 551.02 162.01 548.82 162.59 545.6 164.42 543.31 166.9 541.62 170.72 541.4 172.84 539.79 167.88 537.3 164.79 534.07 162.79 529.71 161.92 526.03 162.52 523.56 163.7 521.35 165.52 519.2 168.72 518.49 170.82 518.19 174.7 519.19 178.14 522.37 182.97 541.17 210.17",
    style: {
      fill: "url(#Unbenannter_Verlauf_61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.31,173.39c0-6.36,5.16-11.52,11.52-11.52,6.36,0,11.52,5.16,11.52,11.52,0,1.42-.26,2.77-.72,4.03-.23.6-.49,1.18-.82,1.73l-21.54,30.9",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.21,173.44c0-6.36-5.16-11.52-11.52-11.52-6.36,0-11.52,5.16-11.52,11.52,0,1.42.26,2.77.72,4.03.23.6.49,1.18.82,1.73l21.52,30.85",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "579.23 194.69 579.21 192.41 575.89 192.12 574.63 190.45 574.7 187.17 573.62 186.99 573.07 185.97 574.12 184.96 574.53 183.01 575.2 180.87 579.65 180.13 579.76 180.36 580.47 181.66 581.38 183.26 582.93 183.3 583.87 184.26 584.03 185.51 583.15 186.44 581.57 186.79 581.67 188.3 582.71 189.85 583.77 191.2 585.4 192.13 585.57 195.06 579.23 194.69",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "582.66 189.82 582.79 190.15 584.19 191.51 585.53 191.72 587.8 183.35 587.47 181.39 586.73 179.77 585.65 178.66 583.31 177.32 580.84 176.88 577.79 177.9 575.77 179.66 575.58 180.35 579.91 180.24 580.88 182.81 581.71 183.39 583.2 183.56 584.03 185.2 583.7 186.4 582.19 187.08 581.44 186.92 581.52 188.37",
    style: {
      fill: "#b07960"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608.81 225.51 604.32 228.71 603.71 230.48 605.95 233.64 607.02 234.76 608.27 234.55 608.64 234.16 609.71 235.17 610.58 234.6 610.66 233.82 611.97 234.01 612.27 232.79 613.15 232.98 613.77 231.98 613.26 231.39 608.81 225.51",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "557.67 198.39 551.95 193.09 551.28 192.81 551.3 193.25 550.96 193.43 551.38 194.37 551.42 194.95 552.87 196.68 552.93 197.17 552.43 197.7 550.57 197.68 549.78 197.76 548.37 199.83 554.2 202.31 557.67 198.39",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "592.21 222.14 572.17 222.65 572.09 205.46 573.34 200.08 576.85 196.25 579.78 195.09 585.57 195.06 589.31 196.71 591.8 200.32 592.95 203.26 592.21 222.14",
    style: {
      fill: "#fff6bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "572.17 222.65 592.21 222.14 592.4 225.89 606.75 263.82 595.34 264.06 582.28 237.61 568.02 267.6 558.71 263.26 572.63 226.26 572.17 222.65",
    style: {
      fill: "#58b3e1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "601.5 264.14 595.34 264.06 596.81 266.11 602.06 265.8 601.5 264.14",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.05 263.28 558.14 265.04 562.33 267.04 563.03 265.38 559.05 263.28",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "602.06 265.8 604.43 271.72 588.88 271.97 587.26 271.29 587.35 269.68 588.2 268.63 596.81 266.11 602.06 265.8",
    style: {
      fill: "#d6e8f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "562.15 267.16 560.06 272.31 559.89 272.92 547.92 266.23 547.44 264.8 548.12 263.73 549.7 263.27 557.29 265.01 562.15 267.16",
    style: {
      fill: "#d6e8f4"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "593.18 204.95 608.87 225.47 602.56 230.39 592.64 217.4",
    style: {
      fill: "url(#Unbenannter_Verlauf_46)",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.73,187.13l.78-.03v3.34c0,1.09.9,1.93,2.03,1.89l2.66-.09v2.89s6.37-.2,6.37-.2v-2.84c.72-3.01,2.16-7.76,2.16-8.52,0-.76.11-2.91-1.83-4.84-.1-.1-2.05-1.96-4.77-1.76-3.03.23-6.16,2.22-6.71,6.02",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.83,187.13c-.47.02-.84-.33-.84-.78,0-.23.1-.43.25-.58",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.32,185.7c1-.68,1.09-1.74,1.09-2.61",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.4,186.8c.21.08.45.11.69.1,1.02-.03,1.86-.87,1.86-1.87s-.83-1.78-1.86-1.75c-.22,0-.42.05-.62.12-.02,0-.04.02-.06.02",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.43,188.22c-.6.36-1.23.62-1.87.79",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.36,
    cy: 184.29,
    rx: 0.42,
    ry: 0.4,
    transform: "translate(-26.86 232.06) rotate(-22.26)",
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 577.11,
    y1: 186.74,
    x2: 578.15,
    y2: 188.85,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.57,192.04c-2.07-.75-3.8-2.44-4.2-5.14",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 575.47,
    y1: 180.43,
    x2: 580.03,
    y2: 180.28,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.33,183.34c-.62-.81-1.06-1.81-1.24-3.01",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 581.72,
    cy: 173.69,
    rx: 3.28,
    ry: 3.18,
    transform: "translate(56.67 478.48) rotate(-46.76)",
    style: {
      fill: "#b07960",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.76,
    y1: 225.33,
    x2: 611.54,
    y2: 228.97,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.15,231.33c-.58-.76-.42-1.87.36-2.47",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.19,230.15c-.3-.38-.22-.93.16-1.24s.93-.25,1.23.12l1.9,2.5c.29.38.2.93-.2,1.24s-.94.23-1.23-.16l-1.88-2.47h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.76,231.26c-.3-.38-.22-.93.16-1.24s.93-.25,1.23.12l1.9,2.5c.29.38.2.93-.2,1.24s-.94.23-1.23-.16l-1.88-2.47h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.26,232.43c-.3-.38-.22-.93.16-1.24s.93-.25,1.23.12l1.9,2.5c.29.38.2.93-.2,1.24s-.94.23-1.23-.16l-1.88-2.47h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.26,231.16l1.9,2.5c.29.38.2.93-.2,1.24s-.94.23-1.23-.16l-2.57-3.39",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.25,231.12c.78-.6.93-1.7.36-2.47",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.94,197.74c.82.25,1.71.26,2.52-.05.26-.1.53-.28.56-.54,0-.14-.05-.28-.11-.39-.37-.67-1.13-1.53-1.26-1.69-.37-.49-.91-1.2-.69-1.74.1-.26.39-.49.68-.49.26,0,.46.17.54.25.46.43,2.51,2.41,5.31,5.15",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.88,199.09c-.59.15-1.14.04-1.68-.23",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 553.65,
    y1: 202.18,
    x2: 548.49,
    y2: 199.82,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "576.94 227.41 596.49 265.68 597.45 267.86",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 605.48,
    y1: 260.69,
    x2: 594.52,
    y2: 261.03,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.41,263.98l2.85,7.47-15.47.49h-.08c-.96,0-1.71-.75-1.7-1.6,0-.74.57-1.45,1.39-1.65,2.67-.85,5.36-1.69,8.03-2.54,1.88-.08,3.75-.16,5.63-.24",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.08,
    y1: 266.58,
    x2: 595.77,
    y2: 268.36,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593.65,
    y1: 267.08,
    x2: 594.35,
    y2: 268.86,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 567.96,
    y1: 267.69,
    x2: 582.03,
    y2: 237.69,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.97,
    y1: 265.09,
    x2: 557.62,
    y2: 267,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.08,272.79l-11.7-6.43h.03c-.81-.49-1.06-1.49-.6-2.25.39-.66,1.25-.99,2.04-.76,2.7.58,5.42,1.15,8.12,1.73,1.52.8,2.59,1.36,4.12,2.16",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 556.6,
    y1: 264.81,
    x2: 556.24,
    y2: 266.71,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 555.24,
    y1: 264.51,
    x2: 554.89,
    y2: 266.42,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 562.86,
    y1: 265.36,
    x2: 560.1,
    y2: 272.78,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 558.77,
    y1: 263.18,
    x2: 567.92,
    y2: 267.73,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 559.88,
    y1: 260.16,
    x2: 568.87,
    y2: 264.88,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.17,195.19c-4.13,1.61-7.11,5.83-7.11,10.69l.26,20.69-.87,2.34-13.52,36.41",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.05,205.22c0-4.96-3.1-9.06-7.38-10.33",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.05,205.22s-.98,20.99-.7,20.7l.87,2.28,13.54,35.57-10.95.34",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 592.23,
    y1: 222.13,
    x2: 572.57,
    y2: 222.74,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 603.57,
    y1: 270.13,
    x2: 587.33,
    y2: 270.63,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.55,
    y1: 271.46,
    x2: 547.89,
    y2: 264.63,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.19,209.23l-11.57-10.89-5.45,5.81,14.5,13.63.1.1c1.36,1.28,3.53,1.18,4.85-.23l.15-.16,13.02-13.84c1.45-1.53,1.41-3.91-.09-5.31s-3.86-1.28-5.3.25l-11.5,12.23",
    style: {
      fill: "#fff6bb",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.69,174.53c.17-.31.28-.67.28-1.04,0-1.2-1.03-2.13-2.3-2.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.66,
    y1: 195.12,
    x2: 541.25,
    y2: 210.05,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.31,173.39c0-6.36,5.16-11.52,11.52-11.52,6.36,0,11.52,5.16,11.52,11.52,0,1.42-.26,2.77-.72,4.03-.23.6-.49,1.18-.82,1.73l-10.06,14.41",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.21,173.44c0-6.36-5.16-11.52-11.52-11.52-6.36,0-11.52,5.16-11.52,11.52,0,1.42.26,2.77.72,4.03.23.6.49,1.18.82,1.73l21.52,30.85",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.64,181.93c-.22-1.21-.85-2.23-1.8-3.01-.53-.44-1.67-1.03-2.35-1.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.01,
    y1: 200.63,
    x2: 570.35,
    y2: 209.84,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.54,216.05c-3.47-3.3-12.43-11.63-12.43-11.63",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 607.08,
    y1: 224.7,
    x2: 596.26,
    y2: 210.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.42,
    y1: 261.83,
    x2: 571.21,
    y2: 232.69,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.66,252.03c0-.17-11.48-22.56-11.48-22.56",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 539.73,
    y1: 205.93,
    x2: 525.25,
    y2: 185.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.68,165.61c-2.88,2.8-4.04,6.96-2.95,10.67",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.21,163.72c-1.7.65-3.42,1.85-4.57,3.29-1.15,1.45-1.77,2.69-2.07,4.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.98,
    y1: 179.93,
    x2: 553.12,
    y2: 191.22,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.16,251.51l-1.09-.63-.69-.53-.41-.82-.34-1.41-.5,1.48-.66,1.01-.78.53-.85.31c-.07.12.97.78.97.78l.75.66.56.91.31,1.35.63-1.67.78-1.04.72-.41.6-.53h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.58,246.48v.95c-.02,2.32-1.59,4.19-3.48,4.18h-.7",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.58,246.48v.95c0,.67.11,1.29.34,1.85.17.42.39.8.66,1.12.37.46.84.81,1.35,1.02.34.14.7.22,1.09.22h.7",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.52,256.76v-.95c.02-2.32-1.53-4.2-3.44-4.21h-.7",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.52,256.76v-.95c.02-2.32,1.59-4.19,3.48-4.18h.7",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_31"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "358.13 227.69 362.33 230.65 358.68 235.88 357.83 236.63 355.93 237.08 354.83 236.84 340.19 227.18 344.07 224.6 344.76 224.49 344.18 223.06 343.69 221.71 343.97 221.31 344.35 221.23 345.01 221.33 346.38 224.4 346.59 225.6 346.1 226.56 355.63 231.34 358.13 227.69",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.97 224.77 344.14 226.63 344.52 227.22 346.1 226.56 347.44 227.18 345.31 230.51 340.19 227.18 343.97 224.77",
    style: {
      fill: "url(#Unbenannter_Verlauf_68)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.24,220.16l1.11-2.35h.03l2.02.21c1,.1,1.88-.62,1.99-1.61l.32-3.06.69.07h-.1c.1,0,.68.05.97-.33.12-.16.21-.42.1-1-.1-.47-.34-1.32-1.17-2.28.34-3.3-2.06-6.26-5.36-6.62-3.3-.34-6.26,2.06-6.62,5.36.17,1.91.27,4.18.44,6.09l.02.1-1.05,2.19",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.51 206.01 314.43 204.88 313.07 203.85 311.72 203.3 310.02 203.11 308.26 203.5 306.44 204.53 305.28 205.69 304.66 207.28 304.29 208.96 304.66 214.63 305.09 214.75 305.75 214.83 306.87 214.88 308.2 214.48 308.74 213.93 309.83 212.55 309.27 212.71 308.46 212.42 307.69 211.86 307.52 211.03 307.74 210.37 308.21 209.68 309.23 209.23 310.06 209.58 311.03 209.52 312.07 208.83 312.92 207.86 313.36 206.54 313.26 207.83 313.72 208.47 314.6 208.61 315.31 208.12 315.8 207.38 315.51 206.01",
    style: {
      fill: "#000001"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.63 234.07 325.32 236.17 333.92 226.94 333.82 225.91 334.04 224.96 335.56 222.44 336.12 222.06 336.65 222.39 336.77 222.95 335.72 225.07 338.03 223.38 340.32 224.79 340.82 224.69 341.29 224.33 341.35 223.44 341.77 223.44 342.23 222.93 342.28 222.34 343.25 221.96 343.72 222.54 343.4 223.42 343.89 223.54 344.19 224.35 343.63 225.01 337.25 229.23 336.87 229.78 328.3 240.97 327.08 242.28 325.65 242.89 323.81 242.81 322.52 241.86 321.25 240.09 319.26 236.97 323.63 234.07",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.14 220.44 278.35 220.93 276.82 220.98 275.58 220.39 274.73 219.55 268.17 207.22 262.85 200.62 262.89 200.14 263 199.78 263.64 199.35 263.62 199 263.75 198.47 264.38 198.06 264.54 197.79 264.73 197.26 265.01 196.93 265.67 197.12 270.53 203.04 270.44 200.97 270.52 200.34 270.89 199.96 271.42 200.08 271.73 200.54 271.99 202.86 272.03 204.21 271.38 205.11 278.7 215.49 283.79 215.12 284.14 220.44",
    style: {
      fill: "#ab7152"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.46 223.48 315.57 222.95 297.78 214.48 296.65 214.04 283.79 215.12 284.3 222.89 292.37 222.43 283.08 242.31 303.09 251.75 312.64 231.9 317.17 238.65 323.6 234.12 316.46 223.48",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.75 254.53 260.72 248.56 257 256.25 276.53 265.56 278.09 265.64 279.44 264.8 282.14 262.27 289.12 255.97 293.61 289.63 302.44 289.55 302.27 251.61 283.58 242.63 273.75 254.53",
    style: {
      fill: "url(#Unbenannter_Verlauf_67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.24,220.16l1.11-2.35h.03l2.02.21c1,.1,1.88-.62,1.99-1.61l.32-3.06.69.07h-.1c.1,0,.68.05.97-.33.12-.16.21-.42.1-1-.1-.47-.34-1.32-1.17-2.28.34-3.3-2.06-6.26-5.36-6.62-3.3-.34-6.26,2.06-6.62,5.36.17,1.91.27,4.18.44,6.09l.02.1-1.05,2.19",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "289.17 256.2 293.51 289.56 302.43 289.62 302.27 251.57",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "314.78 227.13 302.99 251.85 282.89 242.27 292.35 222.43",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.72,
    y1: 214.35,
    x2: 315.37,
    y2: 222.75,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "292.31 222.34 284.41 222.97 283.78 215.03 296.43 214.03",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.87,214.07c.61-.1,1.25,0,1.85.28",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.54,
    y1: 215.44,
    x2: 283.84,
    y2: 215.02,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.2,
    y1: 220.43,
    x2: 278.2,
    y2: 220.91,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.53,
    y1: 215.43,
    x2: 271.33,
    y2: 205.07,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.12,
    y1: 207.08,
    x2: 274.75,
    y2: 219.61,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.13,220.91c-.71.15-1.48.08-2.19-.28-.48-.24-.83-.54-1.12-.94",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.23,202.33c.37.45,3.5,4.25,3.87,4.71",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,202.88l-4.57-5.67c-.25-.31-.71-.37-1.03-.12s-.37.71-.12,1.03l2.86,3.45",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.88,205.21c-.14-1.06.6-2.02,1.66-2.16",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,198.45c-.25-.31-.71-.37-1.03-.12s-.37.71-.12,1.03l2.66,3.25",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.13,199.82c-.25-.31-.71-.37-1.03-.12s-.37.71-.12,1.03l3.06,3.83",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.32,205.1c.69-.51.69-1.48.69-1.48v-.12s-.29-2.78-.29-2.78c.04-.41-.31-.69-.71-.67s-.69.38-.66.78l.21,2.19",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.28,
    y1: 206.89,
    x2: 270.78,
    y2: 205.76,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 265.87,
    y1: 203.04,
    x2: 268.05,
    y2: 201.27,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "294.84 222.18 292.31 222.34 284.41 222.97 283.78 215.03 296.43 214.03",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.84,
    y1: 215.02,
    x2: 278.54,
    y2: 215.44,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "277.41 217.78 278.53 215.43 271.33 205.07",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.12,
    y1: 207.08,
    x2: 274.75,
    y2: 219.61,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.23,202.33c.37.45,3.5,4.25,3.87,4.71",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,202.88l-4.57-5.67c-.25-.31-.71-.37-1.03-.12s-.37.71-.12,1.03l2.86,3.45",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.88,205.21c-.14-1.06.6-2.02,1.66-2.16",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.32,205.1c.69-.51.69-1.48.69-1.48v-.12s-.29-2.78-.29-2.78c.04-.41-.31-.69-.71-.67s-.69.38-.66.78l.21,2.19",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.28,
    y1: 206.89,
    x2: 270.78,
    y2: 205.76,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 265.87,
    y1: 203.04,
    x2: 268.05,
    y2: 201.27,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.76,224.03c-.31-.53-.78-.98-1.38-1.27",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.62,
    y1: 238.34,
    x2: 323.61,
    y2: 233.96,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.17,
    y1: 237.1,
    x2: 322.36,
    y2: 241.69,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.95,
    y1: 229.41,
    x2: 327.75,
    y2: 241.55,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.06,226.01c-.49.32-4.6,3.06-5.08,3.38",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.63,225.02l6.28-4.25c.33-.23.79-.15,1.02.18s.15.79-.18,1.02l-4.08,2.58",
    style: {
      fill: "#ab7152",
      stroke: "#000001",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,227.81c.62-.87.42-2.07-.45-2.68",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.61,222.08c.33-.23.79-.15,1.02.18.23.33.15.79-.18,1.02l-3.77,2.38",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.95,223.62c.33-.23.79-.15,1.02.18s.15.79-.18,1.02l-4.05,2.76",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.06,226.83c-.4-.76-.03-1.82-.03-1.82l.06-.1,1.45-2.4c.14-.38.59-.49.93-.3s.46.65.26.99l-1.12,1.89",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.85,
    y1: 229.01,
    x2: 334.54,
    y2: 227.65,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.96,
    y1: 226.31,
    x2: 338.33,
    y2: 224.03,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "316.44 223.57 323.64 234.02 317.07 238.53 312.58 232",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 323.61,
    y1: 233.96,
    x2: 326.62,
    y2: 238.34,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.4,
    y1: 236.25,
    x2: 334.08,
    y2: 226.89,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.85,
    y1: 229.01,
    x2: 334.54,
    y2: 227.65,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "294.07 253.74 291.55 253.67 280.05 264.36 279.85 264.53",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.76,
    y1: 254.5,
    x2: 283.64,
    y2: 242.67,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "275.58 265.13 257.04 256.29 260.81 248.36 273.73 254.52",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.82,264.54c-1.12,1-2.78,1.28-4.23.6",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.89,289.63c1.88,0,3.76.03,5.63.04,2.83.82,5.1,1.5,6.7,1.96.47.13,1.46.41,1.95,1.25.34.59.3,1.2.3,1.27,0,.11-.06.64-.44,1.13-.36.48-.94.81-1.67.91l-12.55-.13",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.21,
    y1: 294.83,
    x2: 297.04,
    y2: 294.74,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.4,
    y1: 291.69,
    x2: 302.45,
    y2: 289.91,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.2,
    y1: 291.99,
    x2: 304.25,
    y2: 290.2,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.91,
    y1: 292.48,
    x2: 305.97,
    y2: 290.7,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.58,
    y1: 293.02,
    x2: 307.63,
    y2: 291.23,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.86,
    y1: 289.68,
    x2: 296.82,
    y2: 296.02,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.45,251.2c-.81,1.69-1.61,3.4-2.42,5.09-1.93,2.23-3.52,4-4.61,5.25-.32.36-.99,1.14-1.96,1.24-.68.07-1.22-.23-1.28-.27-.1-.06-.54-.32-.84-.88-.28-.53-.33-1.19-.12-1.89l5.43-11.33",
    style: {
      fill: "#f9cabf",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.7,
    y1: 261.99,
    x2: 254.76,
    y2: 249.19,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.68,
    y1: 254.42,
    x2: 256.86,
    y2: 256.12,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.66,
    y1: 255.92,
    x2: 255.84,
    y2: 257.64,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.49,
    y1: 257.28,
    x2: 254.67,
    y2: 258.98,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.3,
    y1: 258.55,
    x2: 253.48,
    y2: 260.26,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.43,
    y1: 251.16,
    x2: 253.69,
    y2: 248.44,
    style: {
      fill: "none",
      stroke: "#010103",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.25,
    y1: 254.95,
    x2: 294.7,
    y2: 289.21,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.05,
    y1: 256.19,
    x2: 284.93,
    y2: 243.36,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.06,
    y1: 256.18,
    x2: 260.42,
    y2: 249.52,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.39,
    y1: 229.36,
    x2: 312.73,
    y2: 231.63,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.98,209.49s-.03-.03-.05-.03c-.16-.08-.34-.13-.53-.15-.9-.1-1.71.56-1.82,1.48s.56,1.74,1.47,1.84c.21.02.42,0,.62-.06",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51,214.99c-.57-.17-1.12-.43-1.64-.78",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.21,
    cy: 210.39,
    r: 0.37,
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.67,212.6c-.82,1.95-3.06,2.86-5.02,2.04",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.84,207.07c-.11.38-.28.74-.54,1.04s-.64.5-1.03.5-.79-.22-.94-.58c-.09-.2-.1-.42-.08-.64.02-.23.05-.46.1-.69-.4.9-.89,1.81-1.66,2.44-.24.2-.51.36-.81.44s-.63.05-.89-.11",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.08,
    y1: 240.24,
    x2: 303.98,
    y2: 249.72,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.26,
    y1: 237.92,
    x2: 304.93,
    y2: 247.48,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.91,241.32c-.59,1-1.7,1.67-2.9,1.67-1.2,0-2.26-.63-2.85-1.57",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.2,227.71l-4.2,2.93,3.2,4.6,1,1.2,1.2.67,1.87-.13,2.13-1.53,8.98-5.88,6.22-3.18.2-1.07-.73-.4s-.07-.87-.13-1.07-1,0-1,0l.47-.8-.6-.73-1.53.33.13-.2c.13-.2-.53-1-.53-1l-3.4,1.6-.8,1.47.27,1.4-10.39,5.4-2.33-3.6h0Z",
    style: {
      fill: "#fdf2e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.5 228.32 393.38 232.44 400.2 227.71 392.23 216.73 391.2 215.78 389.63 215.29 368.19 215.12 366.62 216.24 358.31 227.87 364.94 232.32 367.75 228.39 367.86 248.29 390.46 248.18 390.5 228.32",
    style: {
      fill: "#eb5b5e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.46 248.18 367.86 248.29 361.58 260.54 360.89 261.95 361.04 264.13 361.76 265.86 371.78 282.37 380.72 279.7 372.64 263.2 379.25 252.29 387.85 289.93 397.4 290.11 390.46 248.18",
    style: {
      fill: "url(#Unbenannter_Verlauf_66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.83,290.14c-1.95.73-3.91,1.47-5.86,2.2-1.2.3-1.86,1.48-1.56,2.45.23.74,1.02,1.29,1.93,1.29h-.04,8.39s.1-.05.1-.05l2.23-1.31.27,1.36h2.06s-.97-5.98-.97-5.98",
    style: {
      fill: "#944621",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.71,282.48c-1.64,1.29-3.26,2.6-4.9,3.89-1.06.65-1.31,1.99-.73,2.81.45.65,1.37.92,2.24.65h-.04l7.98-2.58.08-.08,1.71-1.93.67,1.21.06-.02,1.9-.62-2.7-5.27",
    style: {
      fill: "#944621",
      stroke: "#000002",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.22,215.24v-2.45c.49-2.23,1.36-4.29,1.85-6.53.39-4.06-2.84-7.35-6.24-7.25-2.88.09-5.58,2.59-5.9,5.96v.19c.07,1.13-.21,1.62-.49,1.86-.15.11-.46.3-.6.68-.04.1-.11.3-.04.52.13.38.63.47.66.47h-.07s.69,0,.69,0l.02,3.01c0,.98.83,2.05,1.81,2.05l1.31.2h0v1.01",
    style: {
      fill: "#fdf2e7",
      stroke: "#020204",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "367.73 219.6 367.73 248.24 390.66 248.24 390.61 219.59",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.25,
    y1: 215.27,
    x2: 369.12,
    y2: 215.27,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.19,
    y1: 221.64,
    x2: 367.67,
    y2: 224.93,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.91,205.42s.03-.02.05-.02c.17-.06.35-.1.54-.1.9,0,1.63.72,1.64,1.64s-.72,1.66-1.62,1.66c-.22,0-.42-.04-.61-.11",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.19,210.33c.55-.2,1.08-.48,1.57-.85",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.03,
    cy: 205.61,
    r: 0.41,
    style: {
      fill: "#010102"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "390.67 228.62 393.41 232.45 400.07 227.67 392.47 217.05",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.46,217.04c-.7-1.08-1.91-1.78-3.29-1.78",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.66,
    y1: 231.28,
    x2: 400.09,
    y2: 227.69,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 395.94,
    y1: 230.63,
    x2: 399.78,
    y2: 235.96,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "402.13 234.03 402.71 231.33 412.94 225.99",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.93,
    y1: 229.2,
    x2: 403.45,
    y2: 236.76,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.81,236.02c.5.69,1.31,1.13,2.23,1.13.51,0,.99-.13,1.4-.38",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.16,
    y1: 228.43,
    x2: 413.44,
    y2: 226.91,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.02,226.82c.54-.85.37-1.95-.37-2.59",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.85,
    y1: 227.65,
    x2: 414.99,
    y2: 229.15,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.58,223.12l.1-.07,2.55-1.34c.32-.26.77-.12.97.24s.07.81-.3,1.01l-2.23,1.23",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,225.93c-.06-.08-.54-.91-.34-1.68.19-.74.8-1.06.89-1.1",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.59,224.86l2.34-1.22c.36-.18.5-.63.32-.99s-.63-.5-.99-.32l-2.37,1.24c-.36.19-.49.64-.3,1s.64.49,1,.3h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.28,226.18l2.34-1.22c.36-.18.5-.63.32-.99s-.63-.5-.99-.32l-2.37,1.24c-.36.19-.49.64-.3,1s.64.49,1,.3h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,227.57l2.34-1.22c.36-.18.5-.63.32-.99s-.63-.5-.99-.32l-2.37,1.24c-.36.19-.49.64-.3,1s.64.49,1,.3h0Z",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "390.65 248.21 397.36 290.08 387.83 290.1 379.18 252.12 375.84 250.97",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.5,
    y1: 263.22,
    x2: 379.05,
    y2: 252.19,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.83,
    y1: 248.14,
    x2: 361.44,
    y2: 260.71,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "372.47 263.33 380.72 279.59 371.65 282.51 361.64 265.61",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,260.78c-.34.66-.53,1.41-.53,2.2,0,.99.3,1.91.82,2.67",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "390.93 250.96 386.26 250.96 386.26 249.8 390.79 249.8",
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.09,
    y1: 286.18,
    x2: 396.56,
    y2: 286.18,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.75,
    y1: 275.92,
    x2: 369.68,
    y2: 278.85,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.57,
    y1: 294.72,
    x2: 395.1,
    y2: 294.72,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.19,
    y1: 289.06,
    x2: 380.02,
    y2: 284.58,
    style: {
      fill: "none",
      stroke: "#000001",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.38,
    y1: 212.75,
    x2: 378.5,
    y2: 210.58,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "367.58 228.64 364.84 232.47 358.18 227.69 365.78 217.07",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.8,217.06c.7-1.08,1.91-1.78,3.29-1.78",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.59,
    y1: 231.3,
    x2: 358.17,
    y2: 227.71,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.31,
    y1: 230.65,
    x2: 358.47,
    y2: 235.98,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "356.13 234.05 355.54 231.35 346.12 226.43",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.32,
    y1: 229.22,
    x2: 354.8,
    y2: 236.78,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.45,236.04c-.5.69-1.31,1.13-2.23,1.13-.51,0-.99-.13-1.4-.38",
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.78,
    y1: 228.88,
    x2: 345.5,
    y2: 227.36,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33,227.13c-.55-.84-.42-1.93.32-2.57",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.41,
    y1: 227.28,
    x2: 343.28,
    y2: 229.19,
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.23,224.21l-1.15-2.64c-.1-.4-.54-.57-.91-.42s-.55.59-.39.97l.97,2.35",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.17,226.36c.06-.07.77-1.01.1-2.07",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.53,223.29l-1.63-2.08c-.25-.32-.21-.79.11-1.04s.78-.2,1.04.11l1.66,2.1c.25.31.18.78-.13,1.03s-.78.19-1.03-.13h-.02Z",
    style: {
      fill: "#fdf2e7",
      stroke: "#020204",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.36,224.22l-1.63-2.08c-.25-.32-.21-.79.11-1.04s.78-.2,1.04.11l1.66,2.1c.25.31.18.78-.13,1.03s-.78.19-1.03-.13h-.02Z",
    style: {
      fill: "#fdf2e7",
      stroke: "#020204",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.13,225.19l-1.63-2.08c-.25-.32-.21-.79.11-1.04s.78-.2,1.04.11l1.66,2.1c.25.31.18.78-.13,1.03s-.78.19-1.03-.13h-.02Z",
    style: {
      fill: "#fdf2e7",
      stroke: "#020204",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.15,
    y1: 221.64,
    x2: 390.68,
    y2: 224.93,
    style: {
      fill: "none",
      stroke: "#181716",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.83,245.91v-24.81",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.56,
    y1: 227.47,
    x2: 366.38,
    y2: 218.03,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.45,
    y1: 254.19,
    x2: 395.91,
    y2: 288.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.83,
    y1: 260.53,
    x2: 368.23,
    y2: 249.71,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.75,
    y1: 280.63,
    x2: 363.3,
    y2: 266.3,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.5,
    y1: 293.04,
    x2: 387.68,
    y2: 291.14,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.85,
    y1: 286.72,
    x2: 371.99,
    y2: 283.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.43,
    y1: 219.95,
    x2: 398.83,
    y2: 227.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.56,
    y1: 236.33,
    x2: 333.6,
    y2: 228.64,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.43,
    y1: 276.84,
    x2: 301.27,
    y2: 252.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.26,
    y1: 263.68,
    x2: 289.92,
    y2: 253.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.54,
    y1: 248.04,
    x2: 313.37,
    y2: 227.47,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.9,
    y1: 216.3,
    x2: 294.91,
    y2: 215.18,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.57,254.61l-.6.53-.72.41-.78,1.04-.63,1.67-.31-1.35-.56-.91-.75-.66s-1.04-.66-.97-.78l.85-.31.78-.53.66-1.01.5-1.48.34,1.41.41.82.69.53,1.09.63h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.8,254.71h.7c1.89,0,3.46-1.86,3.48-4.18v-.95",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,254.73h-.7c-.38,0-.74-.08-1.09-.22-.51-.21-.98-.56-1.35-1.02-.27-.32-.49-.7-.66-1.12-.23-.55-.34-1.18-.34-1.85v-.95",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.79,254.71h.7c1.9,0,3.46,1.88,3.44,4.21v.95",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.12,254.73h-.7c-1.89,0-3.46,1.86-3.48,4.18v.95",
    style: {
      fill: "none",
      stroke: "#010102",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeyvisualXsRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/keyvisual-xs-rgb.cc953e13b45f69dda5da51b197ae16ee.svg";